
  const html = `<div>

  <div class=WordSection1>

  <p class=MsoAbnormal align=center style='text-align:center;line-height:115%'><b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Terminos y condiciones Wirebit</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Los presentes Términos y Condiciones de uso de la 
  plataforma (en lo sucesivo “Términos y Condiciones”) que rigen la navegación y el uso del Sitio 
  Web www.wirebit.com (En lo sucesivo “Plataforma”) propiedad de Wirebit, S.A.P.I de C.V.
  (En lo sucesivo “Wirebit”).</span></p>

  <div class="calibre" id="calibre_link-0">
<p class=MsoNormal style='text-align:justify'style={{marginTop:30}}><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Los presentes Términos y Condiciones de uso de la plataforma (en lo sucesivo “Términos y Condiciones”) que rigen la navegación y el uso del Sitio Web www.wirebit.com (En lo sucesivo “Plataforma”) propiedad de Wirebit, S.A.P.I de C.V. (En lo sucesivo “Wirebit”).</span></p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>DEFINICIONES </pan> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Para los fines de los presentes Términos y Condiciones, los siguientes términos lingüísticos, tendrán el significado que a continuación se les atribuye, en el entendido que dicho significado será igualmente aplicable al singular y al plural de las definiciones: </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Activo Virtual: </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Representación de valor registrada electrónicamente y utilizada entre el público como medio de pago para todo tipo de actos jurídicos y cuya transferencia únicamente puede llevarse a cabo a través de medios electrónicos </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Cliente:  </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El usuario quien hace uso de los Servicios en la Plataforma Wirebit </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Contraprestación:  </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Las tarifas a las que estará sujetos los Servicios </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Contrato:  </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Documento elaborado unilateralmente por Wirebit para establecer en formatos uniformes los términos y condiciones aplicables a la celebración de las operaciones que lleve a cabo con los Clientes </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Cuenta:  </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Hace referencia al usuario y contraseña que el Cliente genera en la Plataforma wirebit a efecto de que este último tenga acceso la misma y pueda hacer uso de los Servicios. </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Plataforma:  </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Medio de acceso a los Servicios, tanto en plataforma móvil como en la plataforma web www.wirebit.com, propiedad de Wirebit </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Servicios:  </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Los servicios que presta Wirebit consisten en facilitar el intercambio de Activos Virtuales mediante la realización de operaciones de compra o venta de dichos Activos Virtuales propiedad del Cliente a través de la Plataforma Wirebit </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Uso y restricciones de la plataforma</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Los presentes Términos y Condiciones constituyen un acuerdo vinculante entre cualquier Cliente y Wirebit para el uso de la Plataforma. Previamente a la celebración de los presentes Términos y Condiciones, Wirebit le ha informado al Cliente sobre el contenido del mismo, informándole además que mantendrá a su disposición, en la página web de Wirebit y en sus oficinas, versiones actualizadas y vigentes de los términos y condiciones aplicables, así como de los preceptos legales aplicables los cuales se Anexan a los presentes Términos y Condiciones </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Si el Cliente no acepta en forma absoluta y completa los Términos y Condiciones deberá abstenerse de acceder, navegar y/o hacer uso de la Plataforma, en caso contrario se entenderá que da por aceptados voluntariamente, sin ningún vicio en su consentimiento, cada una de las condiciones contempladas en los presentes Términos y Condiciones </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente en este acto manifiesta que en caso de ser persona física actúa por cuenta propia. En caso de ser persona física y actuar en nombre y representación de un tercero Wirebit se reserva el derecho de excluir dicha persona física de la Plataforma </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente garantiza poseer la edad mínima necesaria de 18 (dieciocho) años para utilizar y solicitar cualquier Servicio ofrecido a través de la Plataforma. En caso de no cumplir con la edad mínima, en ninguna circunstancia se tendrá autorización para utilizar la Plataforma </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente deberá de abstenerse de utilizar la Plataforma para fines distintos establecidos en la misma, ni realizar cualquier actividad ilegal, ilícita, fraudulenta o de uso no autorizado </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit se reserva el derecho de excluir al Cliente de la Plataforma, cuando éste no haga un uso adecuado de la misma o de cualquier forma incumpla con los presentes Términos y Condiciones </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Operaciones y servicios que ofrece</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit por medio de la Plataforma, pondrá a disposición de los Clientes los Servicios. La Plataforma será en todo momento operada y administrada por Wirebit. El Cliente reconoce que al solicitar cualquier Servicio dentro de la Plataforma conoce y acepta los términos y características establecidos para efectuar el intercambio de Activos Virtuales. </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit no realiza operaciones traslativas de dominio, sólo pone a disposición del Cliente la Plataforma como un mercado para la compra y/o venta de Activos Virtuales. Las características de las Operaciones y Servicios estarán detalladas en el Contrato respectivo que celebre el Cliente previo a la realización de aquellas </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Disponibilidad de la plataforma</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit mantendrá disponible la Plataforma las 24 horas los 365 días del año. En caso de existir alguna falla dentro de la Plataforma que no permita mantener la disponibilidad indicada, Wirebit notificará vía correo electrónico al Cliente las opciones para continuar con la disponibilidad de los Servicios </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit será responsable de la continuidad de la prestación de los Servicios, la calidad y contenidos de los mismos garantizando la continuidad de la operación conforme al plan de continuidad que Wirebit mantenga para tal efecto </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Mecanismos y procedimientos de identificación y autenticación de clientes.</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Para poder hacer uso de la Plataforma el Cliente tendrá que registrarse y crear una Cuenta en la Plataforma. Para efectos de lo anterior, se le solicita cargar su información para validar y confirmar su identidad. El Cliente no podrá realizar operaciones hasta que proporcione a Wirebit la totalidad de la información y documentación de identificación requerida y ésta sea validada por este último. </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Para la realización de Operaciones en dicha Plataforma, Wirebit podrá solicitar al Cliente dos factores de autenticación, mismos que serán determinados conforme a lo siguiente: el primer factor de autenticación se utiliza en el inicio de sesión en la plataforma donde el Cliente escribe su nombre de usuario y contraseña; y el segundo factor de autenticación se usa para confirmar las operaciones que el Cliente realiza dentro de la Plataforma a través de un pin que se envía a su correo electrónico </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Sin perjuicio de lo anterior, para poder realizar operaciones y brindar los Servicios y celebrar el Contrato respectivo, el Cliente deberá proporcionar toda la documentación e información requerida por Wirebit. El Cliente acepta y reconoce que no podrá hacer uso de los Servicios en caso de que no proporcione los documentos e información requerida. Wirebit podrá solicitar a los Clientes información y documentación donde se haga constar los datos de identificación, domicilio, ocupación, giro mercantil, nacionalidad, clave única de registro de población, Firma Autógrafa Digitalizada, Número telefónico, correo electrónico, entre otras que sean requeridas de conformidad con la Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita, las Reglas de Carácter General a que se refiere Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita y el Reglamento de la Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita. </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente se obliga a proporcionar información verídica por lo que proporcionará Datos Personales a Wirebit a los cuales se les dará el tratamiento y la protección establecidos en el Aviso de Privacidad que se encuentra expuesto en la Plataforma y que el Cliente acepta al ingresar a la Plataforma </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit podrá suspender temporal o definitivamente al Cliente cuyos datos no hayan podido ser confirmados o que los mismos hayan resultado falsos. En dicho supuesto, el Cliente no podrá hacer uso de la Plataforma y se le podrá dar de baja de los posibles Servicios que haya solicitado. Asimismo, si el Cliente no está de acuerdo con los presentes Términos y Condiciones, Aviso de Privacidad y/o Contrato, deberá abstenerse de usar la Plataforma </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>La Plataforma deberá ser utilizada de manera personal, privada y particular por el Cliente, por lo que la Cuenta no podrá de manera alguna ser copiada, modificada, publicada, reproducida o utilizada con fines comerciales </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Recuperación de contraseña</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente acepta que será responsable en todo momento de resguardar las contraseñas de acceso a la Plataforma y será responsable por cualquier robo o extravío de las mismas </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit siguiendo las mejores prácticas de seguridad e identidad no guarda ni conoce las contraseñas de los Clientes por lo que ninguno de sus empleados, funcionarios, accionistas o directores tiene acceso a dicha información </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Para recuperar el acceso a su cuenta el Cliente deberá ingresar al apartado dentro de la Plataforma “recuperar contraseña” y escribir el correo electrónico con el cual realizó su registro. Wirebit realizará la búsqueda del correo electrónico dentro de su base de datos y si este coincide con la información del Cliente se le enviará por correo electrónico una liga mediante la cual podrá crear una nueva contraseña </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Procedimientos y mecanismos para que los clientes reporten el robo o extravío de su información</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de robo o extravío de alguno de los factores de autenticación se protegerá la cuenta del Cliente mediante bloqueo por sistema, el cual impedirá el acceso y la realización de operaciones en la plataforma </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El cliente podrá contactar a soporte al cliente mediante alguno de los medios autorizados para soporte al cliente o vía correo electrónico </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Cuando se reporte una incidencia de este tipo, para efecto de dar seguimiento, se registrará el reporte en la plataforma de atención a clientes. Cuando esto suceda se genera un folio único, mismo que será compartido con el cliente según el medio en el que haya solicitado reporte </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Luego de haber recibido el reporte, Wirebit tomará las medidas bloqueando la cuenta, descrito más abajo, para evitar la realización de operaciones en la cuenta, hasta el desbloqueo de la misma </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Con el propósito de dar seguimiento y mantener informado a los clientes que hayan realizado algún reporte, se registra un ticket en la plataforma de soporte al cliente, misma que enviará un correo electrónico al cliente, con el número de folio asignado. Los clientes podrán dar seguimiento a su caso respondiendo al correo electrónico </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Respecto a las responsabilidades derivadas de las operaciones efectuadas por los clientes previas a un reporte de robo o extravío de su información de identificación o autenticación, Wirebit no se hace responsable de las operaciones realizadas previa a la generación del reporte o mal uso de la cuenta previo al reporte de la incidencia </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Por su cuenta, el cliente tiene como responsabilidad reportar el incidente inmediatamente a Wirebit a fin de bloquear la cuenta e impedir mal uso de la misma. Luego del reporte, Wirebit asume la responsabilidad por el mal uso de la cuenta </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Responsabilidades del cliente y de Wirebit respecto al uso de la plataforma</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente acepta que será responsable de las operaciones que realice en la Plataforma, del resguardo de la información de autenticación necesaria para tener acceso a su cuenta, así como de reportar inmediatamente a Wirebit cualquier incidente respecto de su cuenta </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit  no se hará responsable de las operaciones que el Cliente realice dentro de la Plataforma previas a la existencia de un reporte por parte del Cliente o al mal uso que le pueda dar este último a su cuenta </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit no se obliga a mantener disponibles todos los servicios establecidos en la plataforma </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Aclaraciones relacionadas con operaciones y servicios</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Mecanismos y procedimientos que Wirebit pondrá a disposición de los clientes para atender las aclaraciones relacionadas con operaciones y servicios </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit ha designado al área de Atención a Reclamaciones como la unidad especializada para atender las consultas, reclamaciones y aclaraciones de los Clientes </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El procedimiento de aclaraciones se realizará conforme a lo siguiente </span>:</p>
<p class=MsoNormal style='text-align:justify'style={{paddingLeft:'1em'}}><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> 1. "El cliente enviará un correo electrónico a la siguiente dirección: Hello@wirebit.com,  donde deberá señalar lo siguiente: </span></p>
<p class=MsoNormal style='text-align:justify'style={{paddingLeft:'2em'}}><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> a. Cuenta de correo electrónico personal. </span></p>
<p class=MsoNormal style='text-align:justify'style={{paddingLeft:'2em'}}><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> b. Número de teléfono. </span></p>
<p class=MsoNormal style='text-align:justify'style={{paddingLeft:'2em'}}><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> c. Breve descripción del hecho, objeto de la aclaración. </span></p>
<p class=MsoNormal style='text-align:justify'style={{paddingLeft:'2em'}}><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> d. Agregar evidencia que soporte la aclaración.</span></p>
<p class=MsoNormal style='text-align:justify'style={{paddingLeft:'1em'}}><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> 2. Una vez recibido dicha aclaración, Un Representante del Área de Atención a Reclamaciones de Wirebit contactará al cliente a partir del día laboral siguiente a la recepción del correo electrónico, con la finalidad de corroborar y confirmar la información enviada por el cliente.</span></p>
<p class=MsoNormal style='text-align:justify'style={{paddingLeft:'1em'}}><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> 3. El  Área de Atención a Reclamaciones analizará la solicitud de aclaratoria en un plazo de hasta 15 días laborales contados a partir del contacto realizado con el cliente.</span></p>
<p class=MsoNormal style='text-align:justify'style={{paddingLeft:'1em'}}><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> 4. El  Área de Atención a Reclamaciones ofrecerá una respuesta al cliente el día siguiente al plazo de análisis de la solicitud del cliente."</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Lo antes dispuesto es sin perjuicio del derecho del Cliente de acudir ante la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros o ante la autoridad jurisdiccional correspondiente </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> Comisiones aplicables a los servicios </span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit no realizará cobro alguno por el registro de Clientes en la Plataforma. Las comisiones aplicables a los Servicios estarán disponibles para los Clientes dentro de la Plataforma y en el Contrato correspondiente </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> Derechos de autor y propiedad intelectual</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit, sus logotipos y todo el material que aparece en la Plataforma son marcas, nombres de dominio y nombres comerciales propiedad de Wirebit protegidos por tratados internacionales, leyes federales y locales en materia de propiedad intelectual y derechos de autor. Los derechos de autor sobre el contenido, organización, recopilación, información, logotipos, fotografías, imágenes, videos, programas, aplicaciones, o en general cualquier información contenida o publicada en la Plataforma se encuentra debidamente protegida de conformidad con la legislación aplicable en materia de propiedad intelectual </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Se prohíbe expresamente al Cliente modificar, alterar o suprimir, ya sea en forma total o parcial, los avisos, marcas, nombres comerciales, señas, anuncios, logotipos o en general cualquier indicación que se refiere a la propiedad de información contenida en la Plataforma. El Cliente se obliga a no modificar, reproducir, copiar, rediseñar, aplicar ingeniería inversa, descompilar, adaptar, traducir, preparar trabajos derivados de la Plataforma o utilizarla para desarrollar cualquier software u otros materiales basados en los mismos </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> Confidencialidad</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Queda estrictamente prohibido al Cliente divulgar cualquier información que tenga el carácter de confidencial. Se entiende por información confidencial toda la información contenida dentro de la Plataforma, como lo es: la información referente a los Activos Virtuales, Contratos, actores de las compraventas, estatus de pago, así como cualquier otra información a la que el Cliente tenga acceso dentro de la Plataforma </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En ningún caso el Cliente podrá utilizar la información confidencial a la que tendrá acceso a través de la Plataforma para su beneficio personal, ni para beneficio de terceras personas. El Cliente en ningún caso deberá de utilizar la información confidencial, si esta implica un conflicto de intereses </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que exista un incumplimiento del Cliente, Wirebit, sus filiales y cualquier persona afectada podrá reclamar al Cliente por la vía civil o penal el cumplimiento de esta cláusula más el pago de daños y perjuicios </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> Publicidad</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente reconoce y acepta que Wirebit es una organización independiente de terceros patrocinadores y anunciantes cuya información, imágenes, anuncios y demás material publicitario o promocional puede ser publicado en la Plataforma </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente reconoce y acepta que el material publicitario no forma parte del contenido principal que se publica en el Plataforma. Asimismo, reconoce y acepta con este acto que este material se encuentra protegido por las leyes que en materia de propiedad intelectual e industrial resulten aplicables </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> Modificaciones a la plataforma</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Durante la vigencia del presente Contrato, Wirebit podrá modificar la Plataforma y su contenido, en cuyo caso le informará al Cliente de dichas modificaciones, a través de correo electrónico y la Plataforma </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Quedan exceptuadas de lo dispuesto a lo establecido anteriormente las modificaciones que se realicen para otorgar beneficios a los clientes o para adecuarlos a nuevas disposiciones normativas. En estos casos, únicamente Wirebit dará aviso a los Clientes, a través de la Plataforma </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En el supuesto de que el Cliente no esté de acuerdo con las modificaciones a la Plataforma, podrá solicitar a Wirebit la terminación de la relación dentro de un plazo de 30 (treinta) días naturales contados a partir de la fecha del aviso de modificación, sin que por tal motivo exista responsabilidad alguna a cargo del Cliente, quien únicamente tendrá la obligación de pagar los adeudos que se hubieren generado hasta la fecha efectiva de terminación del servicio por el concepto de comisiones </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> Materiales de terceros</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Es posible que el Cliente tenga acceso en la Plataforma a determinados servicios o materiales de terceros, o se proporcionen enlaces a sitios web de terceros. Al utilizar estos servicios se acepta que Wirebit no asume ni se responsabiliza de ninguno de los servicios o productos del tercero, ni de examinar o evaluar el contenido, la exactitud, la integridad, la vigencia, la validez, el cumplimiento de los derechos de autor, la legalidad, la calidad o cualquier otro aspecto de dichos sitios web o materiales de terceros </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> Modificaciones a los términos y condiciones</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Durante la vigencia del presente Contrato, Wirebit, podrá modificar los presentes términos y condiciones, en cuyo caso le informará al Cliente de dichas modificaciones, a través de correo electrónico y la Plataforma </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Para tal efecto Wirebit informará en la Plataforma un anuncio que incluirá </span>:</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>I.        Nombre del producto o servicio </span>;</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>II.    Resumen de todas las modificaciones realizadas </span>;</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>III.      Fecha a partir de la cual entran en vigor,  </span>y</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>IV.      Derecho del Cliente para dar por terminado los presentes Términos y Condiciones </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Quedan exceptuadas de lo dispuesto a lo establecido anteriormente las modificaciones que se realicen para otorgar beneficios a los clientes o para adecuarlos a nuevas disposiciones normativas. En estos casos, únicamente Wirebit dará aviso a los clientes, a través de la Plataforma, indicando que para conocer los cambios deberá acceder a la Página de Internet de Wirebit </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En el supuesto de que el Cliente no esté de acuerdo con las modificaciones a los Términos y Condiciones, podrá solicitar a Wirebit la terminación del mismo, sin que por tal motivo exista responsabilidad alguna a cargo del Cliente, quien únicamente tendrá la obligación de pagar los adeudos que se hubieren generado hasta la fecha efectiva de terminación del servicio por el concepto de comisiones o contraprestaciones </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Renuncia de garantí </span>a</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit no garantiza que la Plataforma funcionará libre de errores o que la Plataforma y/o su servidor están libres de virus informáticos u otros mecanismos lesivos. Si por el uso de la Plataforma tiene que acudir al servicio técnico o reponer el equipo o datos, Wirebit no será responsable de estos gastos. Wirebit recomienda a los Clientes mantener copias de seguridad de su contenido. En la medida en que lo permita la ley, en ningún caso Wirebit será responsable por el borrado, pérdida o modificación no autorizadas de cualquier contenido de los Clientes </span>.</p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> Disposiciones Adicionales</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Por el hecho de usar las aplicaciones o de solicitar o recibir los Servicios de Wirebit, cada uno de los Clientes declara que (i) está facultado para aceptar y cumplir los Términos y Condiciones, (ii) el cumplimiento de los Términos y Condiciones no contraviene ninguna disposición que le sea aplicable, ni contrato o convenio alguno del que sea parte, (iii) ha obtenido y está en vigor cualquier autorización necesaria para cumplir con los Términos y Condiciones, (iv) no es parte de ningún litigio o controversia que pudiere tener efectos adversos respecto de sus obligaciones conforme a los Términos y Condiciones, (v) tanto cualquier acuerdo de voluntades como los Términos y Condiciones constituyen obligaciones válidas y exigibles en su contra, conforme a sus términos, (vi) se encuentra legalmente posibilitado para otorgar su consentimiento vía electrónica respecto de los presentes Términos y Condiciones: y (vii) no existe una ley o regulación que restrinja o prohíba el uso de nuestros Servicios en la jurisdicción, País o Estado donde el Cliente vive </span>.</p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>De igual forma el Cliente se obliga a indemnizar a Wirebit, así como a sus respectivos funcionarios, directores, colaboradores y empleados (y sacarlos en paz y a salvo de los daños, costos, gastos o pérdidas, incluyendo honorarios razonables de abogados) por conflictos que surjan o se relacionen con el incumplimiento por parte del Cliente a cualquiera de sus obligaciones derivadas de los Términos y Condiciones o la legislación aplicable. </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Cada Cliente que acceda a la Plataforma o que utilice los Servicios de Wirebit, se obliga a indemnizar y sacar en paz y a salvo a Wirebit respecto de cualquier daño o perjuicio que afecte a Wirebit, como consecuencia de cualquier hecho, acto u omisión del Cliente relacionado con el acceso a la Plataforma, los Servicios y conviene que para resarcirse de dichos daños o perjuicios, Wirebit podrá utilizar los recursos que se encuentren en cualquier Cuenta del Cliente o ejercer sus derechos en contra del Cliente conforme a la legislación aplicable, hasta en tanto el daño y/o perjuicio sea resarcido. </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Si alguna disposición de los Términos y Condiciones es inválida o no exigible conforme a la ley aplicable, las disposiciones restantes continuarán en pleno vigor y efecto. </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Los presentes Términos y Condiciones y los derechos y obligaciones aquí previstos, no podrán ser transferidos o cedidos por los Clientes bajo ninguna forma, pero nos reservamos el derecho, de ceder el presente, transferir o asignar la información que hemos recopilado de ti con motivo de una cesión a subsidiarias, afiliadas, controladoras o entidades del mismo grupo empresarial o como consecuencia de cualquier otra operación. </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Para la interpretación, cumplimiento y ejecución de los Términos y Condiciones, las partes convienen que serán aplicables las leyes federales de los Estados Unidos Mexicanos y se someten a la jurisdicción y competencia de los tribunales de la Ciudad de México, renunciando en este acto a aquellos que por ministerio de ley, fuero o residencia le pudieran corresponder, por razón de su domicilio o por cualquier otra causa. El Cliente acepta que los Servicios se consideran realizados en el territorio de los Estados Unidos Mexicanos y más específicamente, en la Ciudad de México. </span> </p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente manifiesta que ha leído las disposiciones de los Términos y Condiciones, y que entiende el alcance de sus obligaciones y derechos derivados de los mismos, asumiendo así las obligaciones que derivan de su consentimiento, no obrando error de derecho o de hecho, violencia, dolo, mala fe, engaño, lesión, incapacidad o cualquier otro vicio que pudiera afectar el consentimiento. </span> </p>
<p class=MsoNormal style='text-align:justify'style={{fontWeight: 700}} ><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> Ley aplicable y jurisdicción</span></p>
<p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Los presentes Términos y Condiciones se regirán e interpretarán de conformidad con la legislación aplicable en materia de Prevención e Identificación de Operaciones con Recursos de Procedencia Ilícita y en lo no previsto  se aplicarán, conforme a su naturaleza y de forma supletoria, las respectivas leyes especiales, las leyes mercantiles, los usos y prácticas bancarias, bursátiles y mercantiles, la legislación civil federal, la legislación penal federal, así como el Código Fiscal de la Federación respecto de la actualización de multas. Cualquier procedimiento de carácter legal que se derive o se relacione con este Contrato será dirimido en los tribunales competentes de San Pedro Garza García, Nuevo León. El Cliente expresamente renuncia a cualquier otra jurisdicción que pudiera corresponderles debido a su domicilio presente o futuro o por cualquier otra razón </span>.</p>
            	<p class=MsoNormal style='text-align:justify'&nbsp;</p>

          </div>

  <br><br>

  <p class=MsoAbnormal align=center style='text-align:center;line-height:115%'><b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Terminos y condiciones Wirebit México</span></b></p>

  <p class=MsoNormal style='text-align:justify'><u><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'><span style='text-decoration:
   none'>&nbsp;</span></span></u></p>

  <p class=MsoNormal style='text-align:justify'><u><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit pone a su
  disposición como Cliente, los presentes términos y condiciones (en adelante los
  Términos), bajo los cuales se regirá la prestación de los servicios de
  aceptación de pagos con tarjeta de Wirebit, mediante la aceptación de los
  presentes Términos el Cliente puede llevar a cabo los cobros de las ventas que
  realice a través de su página por medio de la aceptación de pagos online o con
  tarjeta no presente.</span></u></p>

  <p class=MsoNormal style='text-align:justify'><u><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'><span style='text-decoration:
   none'>&nbsp;</span></span></u></p>

  <p class=MsoNormal style='text-align:justify'><u><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Por lo anterior, el
  cliente acepta y manifiesta su conformidad con las siguientes:</span></u></p>

  <p class=MsoNormal style='text-align:justify'><u><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'><span style='text-decoration:
   none'>&nbsp;</span></span></u></p>

  </div>

  <b><span lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'><br
  clear=all style='page-break-before:auto'>
  </span></b>

  <div class=WordSection2>

  <p class=MsoNormal align=center style='text-align:center'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>DECLARACIONES</span></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Declara WIREBIT que </span><a
  name="_gjdgxs"></a><b><span lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>a)</span></b><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'> es</span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'> una Sociedad
  Anónima de Capital Variable debidamente constituida conforme a las leyes de los
  Estados Unidos Mexicanos, <b>b)</b> Cuenta con la infraestructura de
  tecnologías de información y comunicación, así como con los elementos
  materiales y humanos necesarios para prestar los Servicios.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>II.      Declara el
  Cliente, bajo protesta de decir verdad, según aplique, lo siguiente: a) </span></b><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>ser una
  persona física con la capacidad jurídica necesaria y sin limitación alguna para
  obligarse en la forma establecida en los presentes Términos, o en su caso, ser
  una sociedad debidamente constituida conforme a las leyes de los Estados Unidos
  Mexicanos, debidamente inscrita en el Registro Federal de Contribuyentes. Sea
  persona física o moral: <b>b)</b> Los datos insertados en la Solicitud de servicio
  de este instrumento son ciertos y verídicos, por lo cual, mediante la firma de
  los presentes Términos ratifica la veracidad de dicha información, la cual se
  tiene aquí por reproducida como si se insertare a la letra, formando parte
  integral de este instrumento para todos los efectos legales a que hubiere
  lugar, <b>c)</b> que WIREBIT hizo de su conocimiento que la contratación de los
  Servicios no está condicionada a la contratación de otra operación o servicio, <b>d)</b>
  Reconoce y acepta que WIREBIT podrá designar a cualquier tercero para la
  prestación de los Servicios de procesamiento de Transacciones y otros servicios
  conexos, conforme a lo aquí previsto, por lo que WIREBIT puede delegar el
  cumplimiento de sus obligaciones a ese tercero de acuerdo con lo estipulado en
  los presentes Términos. El Cliente expresa e irrevocablemente otorga su
  consentimiento para que dich<span style='background:white'>o tercero preste los
  Servicios de procesamiento de Transacciones</span> y cumpla las obligaciones de
  WIREBIT en la medida en que no se encuentre prohibido por ninguna normatividad
  aplicable; en el entendido que la prestación de los Servicios de Procesamiento
  de Transacciones y el cumplimiento de las obligaciones por parte del tercero
  será considerado como si WIREBIT hubiera prestado los Servicios y cumplido con
  las obligaciones previstas en  los presentes Términos, para todos los efectos
  legales a los que haya lugar. <b>e) </b>Conoce en forma detallada y específica
  los servicios, condiciones y estándares en que se prestan cada uno de los
  servicios descritos en el presentes Términos, <b>f)</b> Conoce en forma
  desglosada y precisa de los Términos y Condiciones, así como las
  contraprestaciones de los servicios objeto de los presentes Términos, <b>g)</b>
  Recibe de WIREBIT un trato equitativo y no discriminatorio.</span></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>DEFINICIONES</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Para los efectos de los
  presentes Términos, las Partes acuerdan atribuirle a las siguientes palabras el
  significado que en cada uno se define, los cuales podrán ser citados en
  singular o plural.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>I.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Adquirente:</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> Al
  participante en redes que de conformidad con  los presentes Términos que haya
  celebrado con la Cámara de Compensación  provee servicios de pagos en las Redes
  de Pagos con Tarjetas a WIREBIT con la finalidad de que este último ofrezca al
  Cliente el servicio de aceptación de pagos con tarjeta y, provea la
  infraestructura que permita su conexión a las Redes de Pagos con Tarjetas;
  Asimismo es el encargado de a) Recibir las solicitudes de autorización de Pago
  con Tarjetas </span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>(b) tramitar y dirigir a los respectivos Emisores
  las solicitudes de los Clientes a través de la Cámara de Compensación para
  Pagos con Tarjetas; (c) recibir las autorizaciones de pago, rechazos de pago,
  devoluciones y ajustes tramitados por el Emisor para entregarlas al Cliente a
  través del Agregador y a (d) liquidar al Cliente a través del Agregador el
  importe de los pagos con tarjetas.</span></p>

  <p class=MsoListParagraph style='margin-bottom:0in;text-align:justify;
  text-indent:-.5in;line-height:115%;border:none'><b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>II.<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Agregador:</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> Al
  Participante en Redes que, al amparo de un contrato de prestación de servicios
  celebrado con un Adquirente, ofrece al Cliente el servicio de aceptación de
  Pagos con Tarjetas y, en su caso, provee la infraestructura conectada a dichas
  redes. Para efectos de los presentes Términos, el Agregador es WIREBIT.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>III.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Cámara de Compensación:</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  La entidad autorizada por el Banco de México de conformidad con las
  disposiciones de carácter general que éste emite al efecto, para fungir como
  entidad central o para ser la operadora de un mecanismo de procesamiento
  centralizado a través del cual se realizan las acciones que correspondan para
  intercambiar entre Adquirentes y Emisores solicitudes de autorización,
  autorizaciones de pagos, rechazos de pago, devoluciones, ajustes u otras
  obligaciones financieras relacionadas con pagos con tarjetas, incluida la
  compensación.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>IV.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Cliente:</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> La
  persona física o moral que con motivo de la celebración de un contrato de
  prestación de servicios con el Agregador acepta Pagos con Tarjeta de forma electrónica
  o en línea por medio de dispositivos conectados a la Red de Pagos con Tarjetas
  que el Agregador ponga a su disposición y es quien a su vez inicia la solicitud
  de autorización a través del Agregador y recibe la aceptación o rechazo de
  ésta, a través del mismo Agregador.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>V.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Contracargo:</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> Una
  Transacción Disputada por un Tarjetahabiente o Emisor conforme a las
  regulaciones de las Redes de Pagos con Tarjetas vigentes. </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>VI.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Cuenta de Depósito:</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> Tiene
  el significado que se le atribuye en el apartado con el mismo nombre.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>VII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Días Hábiles: </span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Los
  días de la semana en que las entidades financieras en México no estén obligadas
  a cerrar sus puertas ni suspender sus operaciones de conformidad con lo
  establecido en las disposiciones de carácter general que señalan los días del
  año en que las entidades financieras sujetas a la supervisión de la Comisión
  Nacional Bancaria y de Valores deberán cerrar sus puertas y suspender
  operaciones.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>VIII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Emisor:</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> La
  entidad Participante en Redes que expide Tarjetas y que, a través de la Cámara
  de Compensación de Pagos con Tarjeta, recibe las solicitudes de autorización de
  pago que le dirige el Adquirente y genera las respectivas autorizaciones de
  pago, rechazos de pagos, devoluciones y ajustes, con el objeto de ser enviados
  al Cliente a través de la Cámara de Compensación y el Adquirente que
  corresponda.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>IX.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Fondo de Reserva:</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> Monto
  mantenido en custodia de WIREBIT para proveer de </span><span lang=ES-MX><a
  href="http://www.investorguide.com/definicion/fondos.html"><span
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif;
  color:windowtext;text-decoration:none'>fondos</span></a></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  para posibles Contracargos, devoluciones, ajustes, cuotas, tasas y/o
  penalizaciones de las Redes de Pagos con Tarjetas. Los Fondos de Reserva serán
  retenidos por WIREBIT<b> </b>sobre el monto de liquidar por las ventas. El
  dinero se mantiene en custodia de WIREBIT<b> </b>y podrá ser ajustado conforme
  a lo establecido en los presentes Términos.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>X.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Infraestructura:</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> Al software
  propiedad de WIREBIT que pone a disposición del Cliente para integrarlo en su
  Plataforma que permite el acceso a la Red de Pagos con Tarjeta, para instruir
  el pago de bienes o servicios con cargo a una tarjeta, con los requisitos
  establecidos de tiempo en tiempo por Wirebit.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XI.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Ley de Datos Personales:</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  Tiene el significado que se le atribuye en el apartado de <i>Protección de
  Datos Personales</i> de los presentes Términos. </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>XII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Manual Operativo del Cliente:</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  Documento que indica al cliente el proceso operativo para las operaciones en
  línea y el proceso de pago al comercio.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XIII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Monto Mínimo Mensual:</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  Tiene el significado que se le atribuye en el apartado de <i>Liquidación</i>. </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>XIV.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Pagaré de Venta o Comprobante de pago: según
  sea el caso </span></b><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Arial",sans-serif'>1)</span><b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> </span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>El
  registro electrónico entregado al Tarjetahabiente que compruebe la venta del
  bien y/o servicio realizada por el Cliente o 2) El título de crédito
  electrónico entregado al Tarjetahabiente en el que se hace constar la promesa incondicional
  de pago del Tarjetahabiente al Emisor por la cantidad correspondiente a la
  venta realizada por el Cliente.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XV.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Pago con Tarjetas:</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> La
  entrega de recursos al Cliente derivado de la aceptación que éste haya hecho de
  una Tarjeta para cubrir alguna contraprestación cierta por la venta de un bien,
  de un servicio o por cualquier otro concepto, mediante los cargos
  correspondientes en la cuenta vinculada a dicha Tarjeta y al abono del monto
  acordado en la cuenta de depósito del<b> </b>Cliente.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XVI.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Partes:</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> WIREBIT
  y el Cliente de forma conjunta. </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XVII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Participante en Redes:</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  toda persona que de manera habitual preste servicios relacionados con las Redes
  de Medios de Disposición. </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%'><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>XVIII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Plataforma: </span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Es el
  sitio web y/o aplicación para dispositivos móviles propiedad del cliente que
  permite la adquisición de los productos o servicios del cliente por los
  Tarjetahabientes. </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XIX.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Redes de Medios de Disposición: </span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Serie
  de acuerdos, protocolos, instrumentos, interfaces, procedimientos, reglas,
  programas, sistemas, infraestructura y demás elementos relacionados con el uso
  de Medios de Disposición.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XX.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Redes de Pagos con Tarjetas:</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  Infraestructura en donde se procesa el uso de las tarjetas para la aceptación
  de pagos.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXI.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Reglas de las Redes:</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  Tiene el significado que se le atribuye en el apartado del mismo nombre. </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Servicios de Terceros:</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  Tiene el significado que se le atribuye en el apartado de <i>Hardware y
  Servicios de Terceros</i>.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXIII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Servicio: </span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>El
  Servicio que prestará WIREBIT al Cliente para (i) recibir del Cliente las
  solicitudes de autorización de pago con las Tarjetas acordadas en la Solicitud
  de afiliación, (ii) tramitar y dirigir a los respectivos Emisores dichas
  solicitudes a través de las Cámaras de Compensación, (iii) recibir las
  autorizaciones de pago, rechazos de pago, devoluciones y ajustes tramitadas por
  el Emisor para entregarlas al Cliente y (iv) liquidar al Cliente el importe de
  los pagos con Tarjetas que cuenten con la autorización de pago otorgada por el
  Emisor correspondiente. </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXIV.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Solicitud de Servicio: </span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Documento
  que contiene información que permite identificar al Cliente, y que el Cliente
  proporciona a WIREBIT vía electrónica, con la finalidad de contratar los
  Servicios, incluyendo cualquier solicitud adicional y cualquier documento
  entregado por el Cliente en relación con los Servicios objeto de los presentes
  Términos.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXV.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Tarjeta:</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> Se
  denominará así, de manera conjunta a las Tarjetas de Crédito y Tarjetas de
  Débito y tarjetas de Servicios (VISA, MASTERCARD, CARNET).</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXVI.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Tarjetahabiente: </span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>El
  titular de la Tarjeta susceptible de utilizarse en la red de Pagos con Tarjeta.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXVII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Tarjetas de Crédito:</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  Al medio de disposición emitido al amparo de un contrato de apertura de crédito
  en cuenta corriente, que el Emisor otorga al acreditado para que éste, mediante
  la utilización de dicho medio, pueda disponer de la línea de crédito otorgada,
  total o parcialmente, bajo las modalidades de retiro de efectivo, en su caso, o
  pagos en favor de terceros que realice el Emisor por cuenta del acreditado a
  través de la Red de Medios de Disposición que, para dichos efectos, opere la
  Cámara de Compensación.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXVIII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Tarjetas de Débito:</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'> Al
  medio de disposición emitido al amparo de un contrato de depósito de dinero a
  la vista, que el Emisor otorga al depositante para que éste, mediante la
  utilización de dicho medio, pueda, además de realizar otras operaciones de
  retiro, disponer de los fondos en depósito como pagos en favor de terceros que
  realice el Emisor por cuenta del depositante a través de la Red de Medios de
  Disposición que, para dichos efectos, opere la Cámara de Compensación.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXIX.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Términos</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>:  los
  presentes Términos celebrados entre WIREBIT<b> </b>y el Cliente, mediante el
  cual, el primero se obliga a prestar al Cliente el servicio de aceptación de
  Tarjetas como medio de pago. Asimismo, el término incluye la Solicitud de servicio.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXX.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Tasa de descuento o Contraprestación:</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  El pago que debe realizar el Cliente a favor de Wirebit<b> </b>sobre el monto
  de cada Transacción, más el Impuesto al Valor Agregado, por la prestación de
  los Servicios, de conformidad con lo estipulado en el apartado con el mismo
  nombre de los presentes Términos.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXXI.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Titulares de Marcas</span></b><b><span lang=ES
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>:</span></b><span
  lang=ES style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  El participante en redes que sea titular de una marca susceptible de utilizarse
  en Tarjetas y que otorga bajo un contrato, licencias para su uso a Emisores en
  la emisión de Tarjetas y a Adquirentes en la prestación de servicios
  relacionados con ellas y que en su caso establezca condiciones de uso,
  especificaciones técnicas de operación y de garantía. </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%'><b><span lang=ES style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>XXXII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Transacción</span></b><span lang=ES
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>:
  Cualquier operación realizada por un Tarjetahabiente en la Plataforma del<b> </b>Cliente
  utilizando una Tarjeta que implique movimientos en la Cuenta de Depósito o en
  el crédito en cuenta corriente, asociado a dicha Tarjeta.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXXIII.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Transacción Disputada:</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  Operación en la cual el tarjetahabiente genera una aclaración sobre dicha
  operación y que se encuentra en revisión.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXXIV.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Transacción Irregular</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>:
  Cualquier Transacción realizada por el Cliente que se aleje del comportamiento
  habitual de sus operaciones, o que, por su monto, frecuencia o ubicación
  resulten sospechosas. Serán consideradas como Transacciones Irregulares, de
  manera enunciativa, más no limitativa, aquellas señaladas en el apartado de <i>Transacciones
  Irregulares</i>.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><b><i><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>XXXV.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span></i></b><b><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Arial",sans-serif'>Transacciones Prohibidas:</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  Tiene el significado que se le atribuye en el apartado de <i>Restricciones a
  los Servicios.</i></span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><b><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>CONSENTIMIENTO
  </span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Mediante la aceptación
  de los presentes Términos, el Cliente (a) se obliga a cumplir con todas las
  obligaciones a su cargo, y (b) consiente y acepta expresamente lo establecido
  en cada uno de los apartados contenidos en los presentes Términos.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><b><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>DE LOS
  SERVICIOS</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Mediante la aceptación
  de los presentes Términos, WIREBIT<b> </b>se obliga a prestar al Cliente los
  Servicios de Infraestructura tecnológica de procesamiento de pagos para la
  aceptación de Pagos con Tarjeta<i> online </i>o no presente.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><a name="_Hlk36769307"><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>Para utilizar
  los Servicios, el </span></a><span lang=ES-MX style='font-size:8.0pt;
  font-family:"Arial",sans-serif'>Cliente</span><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> deberá abrir y mantener
  una Cuenta de Depósito </span><span lang=ES-MX style='font-size:8.0pt;
  font-family:"Arial",sans-serif'>que haya indicado</span><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> </span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>en la
  Solicitud de </span><span lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>servicio,
  para facilitar el pago por Transacciones</span><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> operadas al amparo de
  los presentes Términos misma que (i) permitirá al </span><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Cliente </span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>aceptar pagos
  online con las Tarjetas<i> </i>y, (ii) permitirá al </span><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Cliente </span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>identificar
  la cantidad de fondos generados de las Transacciones derivadas de la aceptación
  de pagos con Tarjetas.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Para poder recibir los
  Servicios, el Cliente, mediante la celebración de los presentes Términos,
  autoriza a WIREBIT<b> </b>durante la vigencia de los presentes Términos,
  recibir, transferir, retener y/o de cualquier forma disponer de los fondos
  ligados a las ventas realizadas en la Plataforma, con el propósito de liquidar
  al Cliente el importe de las compras realizadas en la Plataforma con Tarjetas.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente entiende y
  acepta que WIREBIT<b> </b>tendrá el derecho de eliminar o agregar Redes de
  Pagos con Tarjetas relacionadas con el uso de estas en cualquier momento y sin
  previo aviso al Cliente sin importar el medio de pago, no obstante, WIREBIT<b> </b>sólo
  procesará las Tarjetas que reciban autorización de las Redes de Medios de
  Disposición y del Emisor. </span><a name="_Hlk44342795"></a></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>PROPIEDAD
  INTELECTUAL</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente no podrá
  hacer uso de las marcas, patentes o signos distintivos de<b> </b>WIREBIT, el
  Adquirente y/o de los Titulares de Marcas para fines distintos a los que se
  señalen en los presentes Términos ni de manera tal, que los Tarjetahabientes
  puedan asumir que los productos y/o servicios que el Cliente ofrece son
  patrocinados o garantizados por<b> </b>WIREBIT, el Adquirente y/o por los
  Titulares de Marcas.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de
  incumplimiento a lo señalado en el presente apartado por parte del<b> </b>Cliente,
  de cualquiera de sus empleados, funcionarios, asesores o agentes, el Cliente se
  obliga indemnizar y resarcir todos los daños y perjuicios que se causen a WIREBIT,
  al Adquirente y/o a los Titulares de Marcas por tal motivo.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'><span
   style='text-decoration:none'>&nbsp;</span></span></u></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>TASA DE
  DESCUENTO O CONTRAPRESTACIÓN</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Por la prestación de los
  Servicios, el Cliente pagará a Wirebit<b> </b>la Tasa de Descuento equivalente
  al porcentaje establecido en la Solicitud de servicio, sobre el monto de cada
  Transacción más el Impuesto al Valor Agregado (“IVA”). El monto de la Tasa de
  Descuento podrá variar de conformidad al tipo de medio de pago empleado, tales
  como Tarjeta de Débito, Tarjeta de Crédito y/o de Servicios. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit<b> </b>podrá
  modificar el monto de la Tasa de descuento mediante notificación realizada al
  Cliente con 15 (quince) días naturales de anticipación a la fecha en que
  realice dicha modificación. Cualquier modificación a la Tasa de descuento se
  entenderá aceptada por el Cliente si no notifica su inconformidad por escrito a
  Wirebit dentro de los 15 (quince) días naturales posteriores a la notificación
  hecha por Wirebit.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit<b> </b>tendrá el
  derecho de cobrar, en cualquier tiempo, vía compensación ejercida al momento en
  que Wirebit liquide al Cliente de acuerdo con lo estipulado en el apartado de
  liquidación:(a) el importe de la Contraprestación por la prestación de los
  servicios objeto de los presentes Términos más el IVA correspondiente, y (b) el
  porcentaje del Fondo de Reserva de conformidad a lo establecido en el apartado
  de <i>Fondo de Reserva , </i>lo anterior, sin necesidad que medie convenio
  adicional para tal efecto.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente conviene que
  el incumplimiento a cualquiera de sus obligaciones de pago contraídas con
  motivo de los presentes Términos, causará intereses moratorios diarios sobre
  los saldos insolutos vencidos que serán calculados diariamente a partir de la
  fecha en que se incurrió en el incumplimiento y hasta la total liquidación de
  estas obligaciones, a la tasa que resulte de adicionar 6% (seis puntos
  porcentuales) a la tasa de interés interbancaria de equilibrio a 28 días
  publicada por el Banco de México por cada día que dure el incumplimiento, o
  cualquier otra tasa que de forma posterior sustituya dicha tasa de interés
  interbancaria de equilibrio a 28 días.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente se obliga a
  no trasladar a los Tarjetahabientes la Tasa de descuento o cualquier importe
  adicional al precio de los productos comercializados en la Plataforma. En caso
  de que WIREBIT<b> </b>se percate o compruebe que el Cliente está llevando a
  cabo dicha práctica, WIREBIT deberá notificar al Cliente a fin de que éste
  subsane dicho incumplimiento en un plazo no mayor a 5 (cinco) días hábiles
  contados a partir de la recepción de dicha notificación. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que el
  incumplimiento persista después de transcurrido dicho plazo o de que el Cliente
  cometa nuevamente dicha conducta, WIREBIT estará facultado para suspender la
  prestación de los Servicios a favor del Cliente, y podrá dar por terminados los
  presentes Términos sin responsabilidad alguna, de acuerdo con lo establecido en
  el apartado <i>Recisión</i>.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>CUENTA DE
  DEPÓSITO</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>A efecto de que WIREBIT
  pueda proveer los Servicios, el Cliente deberá ser titular de una cuenta </span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>de depósito
  de dinero abierta en una Entidad Financiera autorizada para recibir dichos
  depósitos conforme a la normatividad aplicable</span><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>, la cual deberá ser
  indicada a WIREBIT<b> </b>en la Solicitud de servicio (la “Cuenta de Depósito”)
  mediante la cual WIREBIT liquidará al Cliente el importe de los pagos con
  Tarjetas de conformidad con el apartado <i>Liquidación</i>.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente tendrá la
  facultad de cambiar la Cuenta de Depósito, en el entendido de que el Cliente
  deberá notificar y proporcionar previamente a WIREBIT todos los datos que sean
  requeridos por éste<b> </b>para tal efecto, para que WIREBIT pueda realizar la
  liquidación de conformidad con el apartado <i>Liquidación</i>.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que la
  información de la Cuenta de Depósito no sea correcta, será responsabilidad del<b>
  </b>Cliente corregir dicha información, por lo que el Cliente absuelve a WIREBIT
  de cualquier responsabilidad y se obliga a sacar en paz y a salvo a WIREBIT de
  cualquier responsabilidad en la que este último pudiera incurrir como
  consecuencia de la información incorrecta de la Cuenta de Depósito
  proporcionada por el Cliente.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>LIQUIDACIÓN</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Una vez que Wirebit<b> </b>confirme
  que la información de la Cuenta de Depósito es correcta y el Cliente haya
  realizado ventas vía aceptación de Tarjetas, de conformidad con los presentes
  Términos, cuyo monto acumulado sea igual o superior al Monto Mínimo Diario que
  las Partes acuerden, </span><span lang=ES-MX style='font-size:8.0pt;font-family:
  "Arial",sans-serif'>una vez que Wirebit lleve a cabo la conciliación respectiva</span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>  deberá
  depositar o transferir electrónicamente a la Cuenta de Depósito del<b> </b>Cliente
  todos los fondos correspondientes a</span><span lang=ES-MX style='font-size:
  8.0pt;font-family:"Arial",sans-serif'> los pagos con Tarjetas que cuenten con
  la autorización de pago otorgada por el Emisor correspondiente, menos los
  posibles montos de Contracargos, devoluciones, ajustes, cuotas, tasas y/o
  penalizaciones</span><span lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>
  de las Redes de Pagos con Tarjetas y Contraprestaciones respectivas. El Cliente
  en este acto reconoce que deberá pagar cualquier cantidad adeudada a Wirebit<b>
  </b>conforme a los presentes Términos y que se derive de la realización o
  procesamiento de Transacciones.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit<b> </b>tendrá el
  derecho de cobrar, en cualquier tiempo, vía compensación ejercida al momento en
  que Wirebit liquide al Cliente</span><span lang=ES-MX style='font-size:8.0pt;
  font-family:"Arial",sans-serif'> (a) el importe de la Contraprestación por la
  prestación de los Servicios objeto de los presentes Términos</span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'> más</span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'> el IVA
  correspondiente,</span><span lang=ES-MX style='font-size:8.0pt;font-family:
  "Arial",sans-serif'> y (b) el porcentaje del Fondo de Reserva de conformidad a
  los establecido en el apartado Fondo de reserva, de los presentes Términos, lo
  anterior, sin necesidad que medie convenio adicional para tal efecto.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente se obliga a tratar
  de obtener ingresos por la cantidad descrita en la Solicitud de </span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>Afiliación </span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>por concepto
  de ventas mensuales en el entendido que, de no cubrir dicha cantidad mensual,
  deberá cubrir a favor de Wirebit<b> </b>el monto estipulado en la Solicitud de </span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>servicio </span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>(Monto Mínimo
  Mensual).</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Una vez que Wirebit
  lleve a cabo la conciliación respectiva,</span><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'> Las Transacciones serán
  liquidadas por Wirebit a la Cuenta de Depósito del Cliente en un plazo de uno a
  cinco días hábiles posteriores al día de la Transacción.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>No obstante, lo
  anterior, Wirebit no estará obligado a efectuar la liquidación dentro del plazo
  señalado en el párrafo inmediato anterior cuando el Emisor no hubiera liquidado
  dichas Transacciones.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit<b> </b>no podrá,
  ni tendrá la obligación, de depositar o liquidar </span><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>el importe de los pagos
  con Tarjetas, en un país distinto de México.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>ESTADOS DE
  CUENTA</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Siempre que en el
  periodo de que se trate hubiere habido operaciones, WIREBIT pondrá a
  disposición del Cliente vía correo electrónico de manera oportuna, al menos de
  manera trimestral, los estados de cuenta o cualquier documento con el detalle
  transaccional que refleje el detalle global de las Transacciones, Contracargos,
  devoluciones, ajustes, cuotas, comisiones, tasas y/o en su caso, penalizaciones
  de las Redes de Medios de Disposición derivadas del procesamiento de
  Transacciones en la Plataforma y/o cualquier otra cantidad que sea debida a WIREBIT
  de conformidad con los presentes Términos.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Lo anterior en el
  entendido de que el estado de cuenta que proporcione WIREBIT al Cliente
  incluirá las Transacciones correspondientes a las ventas efectuadas en la
  Plataforma.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><a name="_3znysh7"></a><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>Es
  responsabilidad del<b> </b>Cliente conciliar los estados de cuenta donde se
  reflejan los movimientos de las Transacciones enviado por WIREBIT<b> </b>al
  Cliente. Asimismo, es obligación del Cliente revisar el estado de cuenta y debe
  notificar inmediatamente vía correo electrónico a WIREBIT<b> </b>en caso de que
  exista algún<b> </b>error en el estado de cuenta enviado.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Dicha notificación
  deberá contener:</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>El nombre del Cliente,</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>El monto del error,</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Una descripción del error a consideración del
  Cliente.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><a name="_2et92p0"></a><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>WIREBIT<b> </b>deberá
  recibir la notificación vía correo electrónico dentro de los 90 (noventa) días
  naturales posteriores a la terminación del mes al que pertenezca el estado de
  cuenta en el que exista el error. Las Partes acuerdan que si el Cliente no
  notifica a WIREBIT dentro del plazo de 90 (noventa) días naturales, WIREBIT<b> </b>no
  será responsable por cualquier error que el Cliente pueda llegar a identificar
  posteriormente. Durante los 60 (sesenta) días siguientes a que WIREBIT<b> </b>reciba
  del<b> </b>Cliente la notificación del error, WIREBIT<b> </b>realizará las
  diligencias necesarias para dar respuesta al Cliente. </span></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>ACEPTACIÓN DE
  TARJETAS</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Con el fin de que el
  Cliente pueda aceptar las Tarjetas, éste se obliga a usar única y
  exclusivamente la Infraestructura que en este acto será proporcionado por WIREBIT,
  para el servicio de aceptación de Pagos con Tarjetas.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente en este acto
  acepta y reconoce que, en caso de que utilice una Infraestructura distinta a la
  proporcionada por WIREBIT, WIREBIT no tendrá obligación alguna a su cargo en
  relación con las Transacciones realizadas a través de dicha Infraestructura,
  por lo que, la totalidad de las pérdidas, costos o gastos que se generen
  correrán a cargo del Cliente.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente, en la
  aceptación de Tarjetas, tiene la obligación de cumplir con todos los requisitos
  establecidos en los presentes Términos, con los procedimientos que se
  establezcan en el, y/o con cualquier normatividad aplicable.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Asimismo, el Cliente
  deberá ser cuidadoso en generar las Transacciones en la moneda que corresponda.
  Derivado de lo anterior, en caso de que el Cliente haya generado alguna
  Transacción en contravención a lo señalado en el presente párrafo, WIREBIT no
  tendrá obligación alguna a su cargo en relación con dichas Transacciones,
  aceptando en este acto el Cliente que cualquier cargo será por su cuenta, al
  ser el único responsable en realizar la Transacción en cumplimiento a cualquier
  término, condición o normativa aplicable, así como bajo la divisa correcta.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente deberá
  observar los siguientes lineamientos en relación con la aceptación de Tarjetas
  como medio de pago de los productos y/o servicios que deseen adquirir los
  productos ofrecidos a través de la Plataforma del Cliente:</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>El Cliente deberá aceptar cualquier Tarjeta que
  WIREBIT<b> </b>le indique, como medio de pago de bienes y/o servicios que
  comercialice, en las mismas condiciones que el pago en efectivo, no pudiendo en
  ningún caso, cobrar cualquier monto adicional a sus clientes por aceptar dicho
  medio de pago.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Se abstendrá de realizar cualquier tipo de
  discriminación sobre cualquiera de las Tarjetas aprobadas que WIREBIT<b> </b>le
  indique al momento de su recepción, por lo que el Tarjetahabiente deberá contar
  con la posibilidad de decidir libremente la Tarjeta que desea utilizar, sea
  Tarjeta de Débito, Crédito o de servicios.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>El Cliente no podrá efectuar ningún cobro de
  comisión a los Tarjetahabientes por la aceptación del pago con Tarjetas, en
  caso de incumplimiento a lo aquí previsto WIREBIT<b> </b>podrá dar por
  rescindidos los presentes Términos, cancelando los Servicios mediante notificación
  simple.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>El Cliente deberá entregar al Tarjetahabiente
  los Pagarés de Venta, notas de venta, fichas de compra o cualquier otro
  instrumento en que se haga constar alguna Transacción, de manera electrónica,
  precisamente en la fecha en que haya obtenido la clave de autorización asignada
  a dicha Transacción. En ese sentido, el Cliente se encuentra obligado a
  verificar que los datos que aparezcan en los documentos emitidos por la Infraestructura
  coincidan con los datos que aparecen en las Tarjetas.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>El Cliente no podrá hacer uso de la
  Infraestructura en una Plataforma distinta a la señalada en la solicitud de
  afiliación.  Wirebit enviará al Tarjetahabiente y al Cliente los Pagarés de
  Venta o los Comprobantes de Pago correspondientes vía correo electrónico a a
  fin de realizar la liquidación a favor del Cliente. </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>f)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>El Cliente estará obligado a reembolsar a WIREBIT
  el importe de aquellos comprobantes de operación o Pagarés de Venta que
  documenten Transacciones que, habiendo sido liquidados en la Cuenta de Depósito,
  no sean reconocidos por el Emisor o por los Tarjetahabientes.</span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>
  </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>g)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Intentar disuadir a los Tarjetahabientes del
  uso de la Tarjeta.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>h)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Criticar o tergiversar la Tarjeta o alguno de
  nuestros servicios o programas; </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>i)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Imponer restricciones, condiciones o desventajas
  cuando se acepta la Tarjeta que no se impongan de igual manera a todos los
  otros Tarjetas.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;border:none'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que WIREBIT<b>
  </b>se percate del incumplimiento del<b> </b>Cliente a cualquiera de las
  obligaciones anteriormente descritas, WIREBIT<b> </b>deberá notificar por escrito
  al Cliente, para que éste subsane el incumplimiento en un plazo no mayor a 5
  (cinco) días hábiles, salvo la obligación señalada en el inciso (d) anterior,
  cuyo incumplimiento no tendrá plazo de cura.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:.25in'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que el
  incumplimiento persista o el Cliente incurra en reincidencia, WIREBIT<b> </b>podrá
  suspender la prestación de los Servicios y podrá rescindir, sin responsabilidad
  alguna los presentes Términos previa notificación al Cliente.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:.25in'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Sin perjuicio de lo
  anterior, en caso de que WIREBIT: (i) detecte o sospeche que el Cliente lleva a
  cabo Transacciones Irregulares o (ii) que lleven a cabo cualquier tipo de
  práctica que ponga en riesgo la confidencialidad de la información
  transaccional o de los mismos Tarjetahabientes o (iii) bien que realicen actos
  que deriven en un incumplimiento a la normativa aplicable, WIREBIT<b> </b>en
  cuanto tenga conocimiento del hecho, ya sea en forma directa o indirecta, podrá
  suspender los Servicios al<b> </b>Cliente y dar por rescindido, sin responsabilidad
  alguna para WIREBIT,  los presentes Términos en un plazo no mayor a 5 (cinco)
  días hábiles. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>No obstante, cuando WIREBIT
  dé por rescindidos los presentes Términos conforme al párrafo inmediato
  anterior, las Partes convienen en que subsistirán ciertas obligaciones a cargo
  de las Partes, de conformidad con el apartado <i>Terminación.</i></span></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>LÍMITES DE
  TRANSACCIONES</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente reconoce que WIREBIT<b>
  </b></span><span lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>podrá
  establecer límites al monto individual de las transacciones de tiempo en
  tiempo, lo cual hará del conocimiento del Cliente</span><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>. </span></b><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>No obstante,
  lo anterior, WIREBIT, previa notificación del Cliente podrá, a su entera
  discreción, autorizar al Cliente para que lleve a cabo Transacciones que
  superen dicha cantidad, en el entendido que WIREBIT<b> </b>determinará, a su entera
  discreción, el monto máximo por el cual el Cliente podrá realizar la
  Transacción y los días de depósito en los que se realizará la liquidación para
  estas Transacciones. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Los límites de
  Transacciones podrán ser modificados por WIREBIT<b> </b>a su entera discreción,
  mediante notificación realizada al<b> </b>Cliente.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>FONDO DE
  RESERVA</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En este acto el Cliente
  autoriza e instruye a WIREBIT<b> </b>para que,<b> </b>durante la vigencia de
  los presentes Términos, constituya un Fondo de Reserva para garantizar el
  cumplimiento de las obligaciones a su cargo, pudiendo WIREBIT<b> </b>retener la
  cantidad necesaria para asegurar el cumplimiento de las obligaciones del<b> </b>Cliente
  derivadas de los presentes Términos. La cantidad del Fondo de Reserva aparecerá
  en el estado de cuenta. WIREBIT<b> </b>podrá crear un Fondo de Reserva en
  cualquier tiempo y por cualquier razón, incluyendo, sin estar limitado a; un
  alto índice de Contracargos, cancelaciones u otras indicaciones de problemas de
  desempeño del<b> </b>Cliente. El Fondo de Reserva estará constituido por la
  cantidad que, WIREBIT, a su entera discreción, determine como suficiente para
  cubrir cualquier monto de Contracargo o cualquier cantidad por cualquier otro
  concepto que el Cliente llegue a adeudar a WIREBIT.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En todo momento, WIREBIT<b>
  </b>podrá aumentar, reducir devolver o eliminar el Fondo de Reserva, a su
  entera discreción, tomando en consideración (a) el historial de Transacciones
  del<b> </b>Cliente, (b) cualquier cantidad adeudada por el Cliente a WIREBIT</span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'> y (c) La
  antigüedad del Cliente, tomando en cuenta la fecha de suscripción de los
  presentes Términos y (d) El giro del Cliente</span><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente constituye
  como garantía la cantidad de dinero que, de tiempo en tiempo, se encuentre
  depositada en el Fondo de Reserva y autoriza e instruye a WIREBIT<b> </b>para
  disponer en beneficio de éste o un tercero, cualquier monto depositado en el
  Fondo de Reserva, sin necesidad de notificar al Cliente o de requerir cualquier
  autorización adicional, para compensar cualesquiera cantidades que el Cliente
  adeude de conformidad con los presentes Términos.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><a name="_tyjcwt"></a><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>REGLAS DE LAS
  REDES</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente deberá
  cumplir con todas las reglas y normas aplicables que, de tiempo en tiempo sean
  emitidas por el Banco de México y la Comisión Nacional Bancaria y de Valores
  (las “Reglas de las Redes”), por lo que el Cliente se obliga a cumplir
  cabalmente con las Reglas de las Redes y con cualquier modificación que, de
  tiempo en tiempo, sufran.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>WIREBIT<b> </b>podrá
  procesar a solicitud del<b> </b>Cliente cancelaciones de Transacciones con
  Tarjeta, siempre y cuando en todo momento la cancelación sea solicitada por el
  propio Cliente en el mismo día de la Transacción. Las Transacciones con Tarjeta
  respecto de las cuales no se presente una solicitud de cancelación dentro del
  mismo día, no podrán ser canceladas por WIREBIT<b> </b>con posterioridad.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En ninguna circunstancia
  WIREBIT<b> </b>será responsable del procesamiento de devoluciones, reembolsos o
  ajustes relacionados con Transacciones que originalmente no hayan sido
  procesadas por<b> </b>WIREBIT.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>COMPROBANTES
  DE OPERACIÓN</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente se obliga a cumplir
  con los términos y condiciones señalados a continuación por cada Transacción
  que realice:</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
  -.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Arial",sans-serif'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Emitir un comprobante de operación por cada
  Transacción que genere derivado del pago de los productos y/o servicios
  adquiridos por un Tarjetahabiente mediante el Pago con Tarjetas a través de la
  Infraestructura precisando la fecha en la que haya obtenido la clave de
  autorización asignada a dicha operación.</span></p>

  <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
  -.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Arial",sans-serif'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Entregar un ejemplar del comprobante de
  operación al respectivo Tarjetahabiente y conservar otro de conformidad con lo
  establecido en la presente cláusula. </span></p>

  <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
  -.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Arial",sans-serif'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Conservar y almacenar los comprobantes
  originales de operación que respaldan cada una de las Transacciones que fueron
  pagadas a través de las Tarjetas, así como, los documentos que acrediten la
  entrega y en su caso devolución de productos y/o servicios adquiridos, por un
  período mínimo de 10 (diez) años contados a partir de la fecha de su
  generación.</span></p>

  <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
  -.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Arial",sans-serif'>d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Guardar confidencialidad sobre los comprobantes
  de pago de conformidad con los presentes Términos.</span></p>

  <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
  -.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Arial",sans-serif'>e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>El Cliente absuelve a WIREBIT<b> </b>de
  cualquier reclamación derivada de los comprobantes de pago y renuncia a
  cualquier reclamación relacionada con los cargos señalados en dichos
  documentos.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente será
  responsable frente a WIREBIT<b> </b>por cualquier daño o perjuicio que se
  genere derivado del incumplimiento por parte del<b> </b>Cliente al presente
  apartado y pagará a WIREBIT<b> </b>cualquier cantidad que se derive de las
  Transacciones que no sean aceptadas, pagadas y/o aprobadas por el
  Tarjetahabiente o el Emisor. Por lo anterior, el Cliente se obliga a indemnizar
  y sacar en paz y a salvo a WIREBIT<b> </b>de cualquier daño, responsabilidad y
  Contracargo derivado de lo anterior, sin perjuicio de las sanciones a las que
  el Cliente se haga acreedor por los delitos que se pudiesen tipificar de
  acuerdo con la legislación vigente aplicable en la materia.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>RECHAZOS Y
  CARGOS</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente autoriza
  expresamente a WIREBIT<b> </b>a no liquidar el importe de las Transacciones
  generadas a través de la Plataforma, al presentarse cualquiera de los siguientes
  supuestos:</span></p>

  <p class=MsoNormal style='margin-top:0in;margin-right:2.2pt;margin-bottom:0in;
  margin-left:.25in;margin-bottom:.0001pt;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif;color:black'>a)<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Cuando
  la fecha, importe o número de autorización que contenga el comprobante de
  operación, no corresponda con el proporcionado por el Emisor para la
  Transacción respectiva.</span></p>

  <p class=MsoNormal style='margin-top:0in;margin-right:2.2pt;margin-bottom:0in;
  margin-left:.25in;margin-bottom:.0001pt;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif;color:black'>b)<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Cuando
  el comprobante de operación presentado por el Cliente contenga alguna
  alteración en los datos.</span></p>

  <p class=MsoNormal style='margin-top:0in;margin-right:2.2pt;margin-bottom:0in;
  margin-left:.25in;margin-bottom:.0001pt;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif;color:black'>c)<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Cuando
  ante la reclamación de un Tarjetahabiente, el Cliente se vea imposibilitado
  para demostrar que efectivamente entregó las mercancías, producto de las
  Transacciones, en buen estado o de acuerdo con lo descrito en las condiciones o
  especificaciones presentadas al Tarjetahabiente.</span></p>

  <p class=MsoNormal style='margin-top:0in;margin-right:2.2pt;margin-bottom:0in;
  margin-left:.25in;margin-bottom:.0001pt;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif;color:black'>d)<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Cuando
  una Transacción se llevó a cabo con una Tarjeta que no se encontraba vigente al
  momento de dicha Transacción o no reunía las correspondientes características
  de seguridad.</span></p>

  <p class=MsoNormal style='margin-top:0in;margin-right:2.2pt;margin-bottom:0in;
  margin-left:.25in;margin-bottom:.0001pt;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif;color:black'>e)<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Si
  el documento generado como comprobante de la Transacción, es distinto al
  comprobante de operación autorizado por WIREBIT.</span></p>

  <p class=MsoNormal style='margin-top:0in;margin-right:2.2pt;margin-bottom:0in;
  margin-left:.25in;margin-bottom:.0001pt;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif;color:black'>f)<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>En
  caso de que el Cliente genere dos o más comprobantes de operación, derivados de
  una sola Transacción.</span></p>

  <p class=MsoNormal style='margin-top:0in;margin-right:2.2pt;margin-bottom:0in;
  margin-left:.25in;margin-bottom:.0001pt;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif;color:black'>g)<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Cuando
  el nombre, denominación o razón social del<b> </b>Cliente que aparezca en el
  comprobante de operación, sea distinto al registrado ante WIREBIT.</span></p>

  <p class=MsoNormal style='margin-top:0in;margin-right:2.2pt;margin-bottom:0in;
  margin-left:.25in;margin-bottom:.0001pt;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif;color:black'>h)<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Cuando
  el comprobante de operación de la Transacción no contenga número de
  autorización.</span></p>

  <p class=MsoNormal style='margin-top:0in;margin-right:2.2pt;margin-bottom:0in;
  margin-left:.25in;margin-bottom:.0001pt;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif;color:black'>i)<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Cuando
  los comprobantes de operación presentados no ostenten los datos de la Tarjeta,
  del<b> </b>Cliente, o bien, hayan sido incorporados por un medio distinto a la
  Infraestructura que los haya emitido.</span></p>

  <p class=MsoNormal style='margin-top:0in;margin-right:2.2pt;margin-bottom:0in;
  margin-left:.25in;margin-bottom:.0001pt;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif;color:black'>j)<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Cuando
  los comprobantes de operación correspondan a cualquier giro distinto al
  declarado por el Cliente a WIREBIT mediante la Solicitud de afiliación adjunta
  los presentes Términos o a cualquiera de los giros prohibidos conforme a lo
  pactado en el apartado <i>Restricciones de los Servicios</i>.</span></p>

  <p class=MsoNormal style='margin-top:0in;margin-right:2.2pt;margin-bottom:0in;
  margin-left:.25in;margin-bottom:.0001pt;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif;color:black'>k)<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>Cuando
  el Cliente no opere conforme a las instrucciones proporcionadas por WIREBIT por
  el medio que WIREBIT considere adecuado, y de conformidad con el apartado <i>Terminación</i>.</span></p>

  <p class=MsoNormal style='margin-top:0in;margin-right:2.2pt;margin-bottom:0in;
  margin-left:.25in;margin-bottom:.0001pt;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif;color:black'>l)<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>En
  caso de que existan diferencias por los depósitos de los comprobantes de
  operación o en caso de abonos indebidos o improcedentes.</span></p>

  <p class=MsoNormal style='margin-top:0in;margin-right:2.2pt;margin-bottom:0in;
  margin-left:.25in;margin-bottom:.0001pt;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif;color:black'>m)<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>En
  caso de que el Cliente no cumpla con los procesos, medidas y políticas de
  seguridad pactadas por las Partes en  los presentes Términos.</span></p>

  <p class=MsoNormal style='margin-right:2.2pt;text-align:justify;border:none'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify;border:none'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>De presentarse
  cualquiera de los supuestos anteriormente previstos, WIREBIT<b> </b>quedará
  absuelto de cualquier obligación relativa a la liquidación de las Transacciones
  involucradas, por lo que, el Cliente autoriza y expresamente instruye a WIREBIT<b>
  </b>para que descuente de la liquidación correspondiente las Transacciones de:
  Contracargos, devoluciones, ajustes, cuotas, comisiones, tasas y/o en su caso,
  costos operativos o penalizaciones de las Redes de Medios de Disposición
  derivadas del procesamiento de Transacciones y/o cualquier otra cantidad que
  sea adeudada a WIREBIT<b> de </b>conformidad con los presentes Términos.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Sin perjuicio de lo
  anterior, en caso de que WIREBIT<b> </b>no realice el descuento al que se
  refiere el párrafo inmediato anterior, el Cliente deberá pagar a la cuenta que WIREBIT<b>
  </b>indique, cualquier monto o importe que sea adeudado, dentro del día hábil
  siguiente a que WIREBIT<b> </b>le notifique el monto a pagar. </span></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>RIESGOS</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>WIREBIT en este acto
  hace del conocimiento del Cliente que los principales riesgos que existen por
  la utilización de medios electrónicos o automatizados derivados de la
  prestación de los servicios son los siguientes:</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoListParagraphCxSpFirst style='margin-bottom:0in;text-align:justify;
  text-indent:-.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Posible fraude electrónico por robo del
  Identificador de usuario y Contraseña utilizando códigos malignos.</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
  text-indent:-.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Que la operación no pueda ser efectuada.</span></p>

  <p class=MsoListParagraphCxSpLast style='margin-bottom:0in;text-align:justify;
  text-indent:-.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Acceso a portales falsos comprometiendo los
  datos de autenticación del Cliente.</span></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>CONTRACARGOS</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente es
  completamente responsable frente a WIREBIT, obligándose a pagar a WIREBIT<b> </b>la
  totalidad de cualquier monto que se origine de un Contracargo. Ante los siguientes
  supuestos que se mencionan de forma enunciativa más no limitativa; el Cliente
  será responsable frente a WIREBIT en los siguientes supuestos: (a) cuando
  exista una disputa acerca de la validez de una Transacción por parte del
  Tarjetahabiente o el Emisor, (b) cuando una Transacción sea rechazada por una
  de las Redes de Pagos con Tarjetas, un comprador del<b> </b>Cliente, Emisor, o
  por cualquier otro motivo, (c) cuando no sea autorizada una Transacción o WIREBIT<b>
  </b>tenga cualquier razón para creer que la Transacción no fue autorizada, o
  (d) cuando una Transacción se considere presuntamente ilegal, sospechosa o
  viole las condiciones de  los presentes Términos.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente está de
  acuerdo en reconocer cualesquiera Contracargos y sus montos, por lo que será
  responsable frente a WIREBIT<b> </b>por la totalidad del monto de cualquier
  Transacción por la cual, el Tarjetahabiente o el Emisor disputen por cualquier
  razón la validez de la Transacción. En virtud de lo anterior, y con fundamento
  en lo previsto en el artículo 2596 del Código Civil Federal, el Cliente
  autoriza e instruye irrevocablemente a WIREBIT para compensar las cantidades
  adeudadas por el Cliente a su favor, ya sea mediante compensación ejercida o
  mediante cargo al Fondo de Reserva. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que WIREBIT<b>
  </b>razonablemente sospeche que alguna Transacción con Tarjeta pueda resultar
  en un Contracargo, WIREBIT<b> </b>podrá retener en el Fondo de Reserva el monto
  de la Transacción con Tarjeta que resulte suficiente para cubrir cualquier
  potencial monto de un Contracargo.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que el
  Cliente no mantenga recursos suficientes en el Fondo de Reserva para cubrir
  cualquier monto de un Contracargo, WIREBIT podrá, vía compensación ejercida al
  momento de realizar la liquidación al Cliente, cobrar los montos de los
  Contracargos al Cliente. En caso de que los montos de los Contracargos sean
  superiores a los fondos antes citados, el Cliente se obliga a transferir a WIREBIT<b>
  </b>fondos suficientes para cubrir los montos de los Contracargos y cualquier
  otro gasto erogado por WIREBIT<b> </b>para atender estas aclaraciones.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente estará
  obligado a prestar a WIREBIT<b> </b>la asistencia necesaria para investigar
  cualquier Transacción procesada por WIREBIT<b> </b>que resulte en un
  Contracargo y deberá facilitar a WIREBIT<b> </b>cualquier información que
  resulte necesaria o conveniente para disputar cualquier Contracargo.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Si la disputa de un Contracargo
  no es resuelta por parte de la Red o el Emisor en favor del<b> </b>Cliente, o
  el Cliente elige no disputar el Contracargo, WIREBIT<b> </b>tendrá el derecho,
  pero no la obligación, de disputar el Contracargo y cualquier tarifa asociada a
  dicho Contracargo en nombre del Cliente.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente reconoce que WIREBIT<b>
  </b>suspenderá los Servicios y, en consecuencia, se abstendrá de procesar
  cualquier Transferencia o pago que realice el Cliente, en caso de que los
  Contracargos del<b> </b>Cliente superen el [5]% ([cinco por ciento]) de las
  Transacciones del<b> </b>Cliente dentro de un mes calendario.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>CONFLICTOS DE
  INTERÉS</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Las Partes y su personal
  deberán cumplir con las normas éticas y políticas sobre conflictos de interés,
  obligándose a evitar situaciones en las que se puedan incurrir en dichos
  conflictos.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Le queda estrictamente
  prohibido al Cliente permitir el ofrecimiento de incentivos o regalos a
  empleados y funcionarios de WIREBIT y/o del Adquirente, o de cualquier entidad
  gubernamental, ya sea del poder ejecutivo, legislativo o judicial, a fin de
  obtener con ello beneficios para el Cliente, WIREBIT<b> </b>y/o el Adquirente.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>RESTRICCIONES
  A LOS SERVICIOS</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente deberá
  abstenerse de utilizar los Servicios para aceptar pagos relacionados con los
  siguientes negocios o actividades de negocios: (a) actividades y/o bienes
  ilícitos, (b) clubes de descuentos o membresías, incluidas las cuotas
  relacionadas con dichos clubes, (c) asesoría para la obtención o reestructura
  de créditos, (d) servicios de protección de crédito e identidad, (e) ofertas o
  servicios de mercadotecnia directa o mediante suscripción, (f) ventas de
  infomerciales, (g) negocios de mercadotecnia no autorizados, (h) vendedores a
  través de llamadas telefónicas, (i) tarjetas de teléfono o tarjetas de teléfono
  pre-pagadas, (j) negocios con base en descuentos, (k) comerciantes de venta
  adicional (<i>up-selling</i>), (l) servicios de pago de recibos, (m) apuestas,
  incluidos billetes de lotería, fichas de juego de casino, apuestas fuera de un
  hipódromo autorizado y apuestas en carreras no permitidos por la ley, (n)
  dispensadores manuales o automatizados de efectivo, (o) tarjetas pre-pagadas,
  cheques u otras mercancías o servicios financieros, (p) ventas de giros
  postales o divisas, (q) transferencias bancarias y giros postales, (r)
  productos y servicios de alto riesgo, incluidas las ventas por
  telemercadotecnia<i> </i>(<i>telemarketing</i>), (s) comerciantes de estaciones
  de servicio, (t) dispensadores de combustible automatizados, (u) productos o
  servicios para entretenimiento de adultos (a través de cualquier medio,
  incluido el Internet, teléfono o material impreso), (v) ventas de (i) armas de
  fuego, partes o accesorios de armas de fuego y municiones, o (ii) armas y otros
  dispositivos diseñados para causar lesiones físicas, (w) ventas de cigarrillos
  o tabaco por Internet, correo, o teléfono, (y) accesorios o utensilios para
  consumir drogas, (z) productos que puedan causar daño, (aa) servicios de
  acompañante, (bb) abogados para la gestión de bancarrotas, (cc) agencias de
  cobranza involucradas en la cobranza de deuda (dd) farmacias por internet, (ee)
  venta de tabaco por internet, (ff) servicios relacionados con viajes y arreglos
  relacionados (excluyendo las agencias de viajes), o (gg) pornografía y Giros
  negros (derivados de actividades ilícitas, prostitución, etc.) (en conjunto,
  las “Transacciones Prohibidas”) </span><span lang=ES-MX style='font-size:8.0pt;
  font-family:"Arial",sans-serif'>y cualquier otro giro o transacción prohibida
  que Wirebit a su entera discreción establezca de tiempo en tiempo. </span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que WIREBIT<b>
  </b>sospeche que el Cliente ha realizado una Transacción Prohibida, WIREBIT<b> </b>transferirá
  los fondos derivados de la Transacción Prohibida al Fondo de Reserva y
  restringirá al Cliente el uso de la Cuenta de Depósito indicada en la Solicitud
  de afiliación para su operación, en tanto WIREBIT<b> </b>realiza una
  investigación para determinar si el Cliente ha realizado una Transacción
  Prohibida.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que WIREBIT<b>
  </b>determine que el Cliente ha realizado una Transacción Prohibida, WIREBIT<b>
  </b>tendrá el derecho de suspender la prestación de los Servicios y dar por
  terminados los presentes Términos, sin responsabilidad alguna para WIREBIT.
  Asimismo, WIREBIT<b> </b>tendrá la facultad de cobrar al Cliente el monto del
  cargo de la Transacción Prohibida como pena convencional.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que cualquier
  Transacción viole los presentes Términos o cualquier otro contrato celebrado
  entre el Cliente y WIREBIT, o en caso de que WIREBIT<b> </b>prevea que la
  autorización de dicha Transacción pueda causar algún daño o perjuicio al
  Cliente, a<b> </b>WIREBIT, o a otros usuarios de los Servicios, entonces WIREBIT<b>
  </b>tendrá la facultad de no procesar o autorizar cualquier Transacción con
  Tarjeta ligada a la Cuenta de Depósito que mantenga el Cliente con WIREBIT. </span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>CONFIDENCIALIDAD</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente se obliga a proteger
  la confidencialidad y a no divulgar los datos e información del Tarjetahabiente
  y de la información transaccional y se obliga a mantener controles físicos,
  técnicos y administrativos para prevenir el acceso a terceros no autorizados a
  la información antes citada, así como a proteger la Infraestructura, sistemas y
  equipos que contengan la información del Tarjetahabiente e información
  transaccional.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente se obliga a
  no almacenar cintas magnéticas o datos CVV2/CVC2/CID después de la autorización
  de la Transacción. El Cliente tiene prohibido imprimir en los comprobantes de
  pago o en cualquier otro documento que sea entregado al Tarjetahabiente, el
  contenido completo de la cinta magnética o los datos del CVV2/CVC2/CID.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente deberá
  abstenerse de publicar, transmitir, distribuir o divulgar cualquier material
  que: (a) sea falso, engañoso, ilegal, obsceno, indecente, lascivo,
  pornográfico, difamatorio, calúmniate, amenazante, hostigante, racista, abusivo
  o altisonante, (b) que motive una conducta que pueda ser considerada como un
  acto delictivo o que dé origen a responsabilidad civil, (c) viole cualquier
  obligación o derecho de cualquier persona o entidad, incluidos los derechos de
  privacidad o de propiedad intelectual, (d) contenga datos o archivos dañinos o
  cualquier virus, (e) anuncie productos o servicios que compitan con los
  productos y/o servicios de<b> </b>WIREBIT, según lo determine WIREBIT<b> </b>a
  su entera discreción, o (f) a entero juicio de WIREBIT, pueda exponer a WIREBIT<b>
  </b>sus filiales, subsidiarias, o a sus clientes a cualquier daño, perjuicio o
  responsabilidad de cualquier naturaleza.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>SEGURIDAD,
  INTERCAMBIO DE INFORMACIÓN Y AUDITORÍAS.</span></u></b></p>

  <p class=MsoNormal style='margin-left:21.3pt;text-align:justify;text-indent:
  -21.3pt'><span lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoListParagraphCxSpFirst style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:.25in;text-align:justify;text-indent:-.25in;
  line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Contraseñas Electrónicas</span></b><span
  lang=ES-MX style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>.
  El Cliente deberá mantener cualquier contraseña relacionada con los Servicios
  como confidencial e impedir que cualquier persona la utilice. El Cliente
  reconoce que será responsable por todas las acciones hechas mediante el uso de
  la contraseña, incluyendo el uso indebido de la misma.</span></p>

  <p class=MsoListParagraphCxSpLast style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:.25in;text-align:justify;text-indent:-.25in;
  line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Suspensión</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>. WIREBIT
  podrá suspender la prestación de Servicios objeto de los presentes Términos en
  caso de que WIREBIT<b> </b>identifique Transacciones que salgan de los
  parámetros habituales o no correspondan al giro del<b> </b>Cliente, o bien, se
  identifiquen como Transacciones que pudiesen ser de alto riesgo o asociadas a
  conductas fraudulentas en función de su monto o frecuencia. En caso de no
  corregir las anomalías detectadas, WIREBIT<b> </b>tendrá la facultad de no
  reestablecer el Servicio y, en dicho caso, el Cliente responderá por cualquier
  daño o perjuicio ocasionado a WIREBIT<b> </b>por tal motivo.</span></p>

  <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
  -.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Arial",sans-serif'>c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Prohibiciones</span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>. El
  Cliente no podrá realizar operaciones de refinanciamiento, de pago de adeudos
  anteriores o de cobros de cheques o cualquier otro instrumento financiero vía
  Tarjeta o utilizar para sí mismo las Tarjetas que cualquier Emisor haya
  expedido a su nombre.</span></p>

  <p class=MsoNormal style='margin-left:21.3pt;text-align:justify;text-indent:
  -21.3pt;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Arial",sans-serif'>d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Auditorias: </span></b><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'>El
  cliente acepta que Wirebit o el tercero que éste designe podrá llevar a cabo
  auditorias, para asegurarse del cumplimiento de las obligaciones a cargo del
  Cliente, conforme a lo establecido en los presentes Términos.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>TRANSACCIONES
  IRREGULARES</span></u></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Son transacciones irregulares,
  de manera enunciativa más no limitativa, las señaladas a continuación (las
  “Transacciones Irregulares”):</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
  -.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Noto Sans Symbols"'>●<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>En las que el mismo Tarjetahabiente efectúe
  varios consumos utilizando Tarjetas de distintos Emisores.</span></p>

  <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
  -.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Noto Sans Symbols"'>●<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>En las que el mismo Tarjetahabiente presente en
  diversas ocasiones en la Plataforma del Cliente en diferentes horarios.</span></p>

  <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
  -.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Noto Sans Symbols"'>●<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>En las que diferentes personas realicen
  diversas compras utilizando la Tarjeta de un mismo Tarjetahabiente.</span></p>

  <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
  -.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Noto Sans Symbols"'>●<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>En las que se utilicen Tarjetas reportadas como
  robadas, inválidas o extraviadas, o bien, cuando así le sea indicado al momento
  de solicitar la autorización de la operación (debiendo en estos casos obtener
  una clave de identificación de la instrucción correspondiente). </span></p>

  <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
  -.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Noto Sans Symbols"'>●<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
  -.25in;line-height:115%'><span lang=ES-MX style='font-size:8.0pt;line-height:
  115%;font-family:"Noto Sans Symbols"'>●<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>En las que se utilicen Tarjetas donde el Cliente
  tenga la sospecha de que la Tarjeta es robada, clonada, inválida o no es
  propiedad de la persona que la está intentando usar como medio de pago.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que el
  Cliente no realice cualquiera de las acciones señaladas en la presente
  cláusula, el Cliente responderá ante WIREBIT<b> </b>por cualquier daño, gasto,
  sanción, multa o perjuicio que le sea causado a este último, debiendo asumir el
  Cliente el costo completo de la Transacción que se haya realizado en
  contravención a lo aquí estipulado.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>WIREBIT<b> </b>se reserva
  el derecho de verificar el cumplimiento del<b> </b>Cliente respecto a la
  implementación de las medidas preventivas y correctivas particulares y de
  supervisión establecidas en los presentes Términos.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente es
  responsable por las acciones de sus empleados, por lo que en los casos en que
  se demuestre que, uno o varios empleados de éste, incurren en conductas
  negligentes, colusión o que éstos favorecieron o no reportaron Transacciones
  Irregulares ni tomaron las medidas mencionadas en la presente cláusula, el Cliente
  autoriza a WIREBIT<b> </b>para que cargue en su Fondo de Reserva las cantidades
  que WIREBIT tuviere que erogar por estos conceptos. En caso de que el saldo en
  su Fondo de Reserva sea insuficiente, el Cliente se obliga a pagar a WIREBIT<b>
  </b>los montos correspondientes a más tardar el día hábil siguiente a que WIREBIT<b>
  </b>le notifique al Cliente. Asimismo, el Cliente se compromete a actuar de
  manera conjunta con WIREBIT<b> </b>para presentar las denuncias y querellas que
  correspondan en contra de los supuestos responsables.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:.25in'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente colaborará
  incondicionalmente con WIREBIT y/o con las autoridades competentes y/o con los
  terceros que WIREBIT<b> </b>indique, en la investigación, denuncia y/o
  esclarecimiento de cualquier ilícito realizado en la Plataforma, relacionados
  con las obligaciones pactadas en los presentes Términos, con el propósito de
  presentar las denuncias correspondientes. Dicha colaboración incluye que el
  Cliente proporcione a WIREBIT<b> </b>los documentos e información necesaria,
  tales como: copias de comprobantes, facturas, detalle de la mercancía,
  registros del comprador, domicilio de entrega, datos del vendedor o empleado
  involucrado o cualquier otro elemento que pudiere requerirse en la
  investigación.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:.25in'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>SUSPENSIÓN DE
  PAGOS O HUELGA</span></u></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente se obliga a
  informar a WIREBIT<b> </b>en los casos de suspensión de pagos, huelga, quiebra
  o de cualquier proceso judicial que se haya promovido en su contra que afecte
  su capacidad para poder cumplir con las obligaciones que asume al amparo de los
  presentes Términos, en un plazo no mayor a 3 (tres) días naturales contados a
  partir de la fecha del evento o de la fecha en la que el Cliente tenga
  conocimiento de este.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>DOCUMENTOS E
  INFORMACIÓN</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente se obliga a
  proporcionar vía correo electrónico a<b> </b>WIREBIT, la cual será parte del
  expediente que éste último integre:</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>A.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Tratándose de personas físicas, el Cliente
  deberá proporcionar:</span></b></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>i.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Identificación oficial vigente del<b> </b>Cliente,
  </span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>ii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Comprobante de domicilio del<b> </b>Cliente,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>iii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Datos de la Cuenta de Depósito del<b> </b>Cliente
  para los fines de los presentes Términos, siendo responsabilidad exclusiva de
  éste proporcionar los datos correctamente,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>iv.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Número Telefónico del<b> </b>Cliente,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>v.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Correo electrónico del<b> </b>Cliente,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>vi.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>En su caso cédula del Registro Federal de Contribuyentes
  del Cliente.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>B.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><b><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Tratándose de personas morales, el Cliente
  deberá proporcionar:</span></b></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>i.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Identificación oficial vigente del
  Representante legal del Cliente y de cada uno de los accionistas o socios de
  éste,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>ii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Comprobante de domicilio,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>iii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>En su caso, comprobante de domicilio del
  Cliente, del representante legal del Cliente y de cada uno de los accionistas o
  socios de éste,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>iv.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Cédula del Registro Federal de Contribuyentes,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>v.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Autorización para consulta del Buró de Crédito,
  suscrita por el Representante Legal del Cliente y, en su caso, por cada uno de
  los socios o accionistas,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>vi.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Inscripción en el Registro Federal de
  Contribuyentes (Alta de Hacienda) o en su caso, cualquier modificación que
  dicha inscripción haya sufrido,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>vii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Acta constitutiva del<b> </b>Cliente con los
  datos de inscripción de esta en el Registro Público de la Propiedad y del
  Comercio,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>viii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Escritura Pública donde consten los estatutos
  vigentes del<b> </b>Cliente con los datos de inscripción de esta en el Registro
  Público de la Propiedad y del Comercio,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>ix.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Poder del Representante Legal que suscribirá
  los presentes Términos con los datos de inscripción de este en el Registro
  Público de la Propiedad y del Comercio, en su caso,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>x.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Datos de la Cuenta de Depósito del<b> </b>Cliente
  usada para los fines de los presentes Términos,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>xi.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Número telefónico del contacto por parte del<b>
  </b>Cliente que vigilará el cumplimiento de los presentes Términos,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>xii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Correo electrónico del contacto por parte del<b>
  </b>Cliente que vigilará el cumplimiento de los presentes Términos.</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -1.0in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>xiii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Opinión de cumplimiento de obligaciones fiscales
  emitido por el Sat, cuya antigüedad no sea mayor a (30) treinta días. El
  cliente deberá contar con la actualización de la opinión mencionada en el
  presente numeral de manera mensual.</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;border:none'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>CAPACITACIÓN</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>WIREBIT<b> </b>mantendrá
  un programa de información y capacitación para los empleados del<b> </b>Cliente
  para el manejo de la Infraestructura y la generación de las Transacciones de
  conformidad con lo que para tal efecto señale WIREBIT<b> </b>al<b> </b>Cliente.</span></p>

  <p class=MsoNormal style='text-align:justify'><a name="_3dy6vkm"></a><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>INFRAESTRUCTURA</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Las partes acuerdan que WIREBIT
  concederá al Cliente la licencia de uso no exclusivo e intransferible al
  Cliente de la Infraestructura a través del cual WIREBIT presta los servicios
  objeto de los presentes Términos, por lo anterior, el Cliente se obliga a:</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>i.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Instalar y utilizar la Infraestructura de
  conformidad con las condiciones y especificaciones que a su vez WIREBIT le
  indique para tal efecto;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>ii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>No procesar información a través de la
  Infraestructura que no sea la de sus propios Clientes;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span>iii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>No ceder, licenciar, sublicenciar, distribuir,
  permitir la distribución, modificar, vender, alquilar, rentar, arrendar,
  permitir el uso, prestar, dar en garantía o transferir de cualquier forma la
  Infraestructura o los manuales y demás documentos relacionados con el mismo;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span>iv.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>En su caso, hacer una copia simple de la
  Infraestructura con el único propósito de crear un respaldo de este, sin que
  pueda utilizar dicha copia para otro fin;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>v.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Devolver o garantizar la destrucción y
  desinstalación de la Infraestructura a WIREBIT, así como los manuales y
  cualquier otro documento relacionado con éste, al día hábil siguiente a aquel
  en que WIREBIT se lo requiera por escrito o al no continuar aceptando los
  presentes Términos.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span>vi.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>No permitir o autorizar el uso de la
  Infraestructura a persona física o moral alguna que no esté directamente
  relacionada con la operación de su negocio;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
  </span>vii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>No permitir a terceros la exportación o
  transferencia de la Infraestructura fuera del lugar donde haya sido
  originalmente instalado;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
  </span>viii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>No copiar o reproducir la Infraestructura,
  salvo en lo permitido en el inciso iv) anterior;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span>ix.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>No modificar, alterar, adaptar, desarmar,
  decodificar, descompilar o emplear procesos para revertir la ingeniería de la
  Infraestructura o de cualquier candado o dispositivo de seguridad usado o
  proporcionado por la Infraestructura, ni intentar o permitir a tercero alguno
  el intentar obtener los algoritmos por los cuales la Infraestructura realiza
  sus funciones;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>x.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>No permitir o causar, directa o indirectamente,
  que un tercero modifique, altere, adapte, desarme, decodifique, descompile o
  emplee procesos para revertir la ingeniería de la Infraestructura o de
  cualquier candado o dispositivo de seguridad usado o proporcionado por la
  Infraestructura;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span>xi.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>No fusionar en ninguna forma la Infraestructura
  con otros programas de cómputo de forma tal que pudieran comprometer su
  funcionalidad, desempeño e integridad de la información; y </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
  </span>xii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>No dañar la Infraestructura, ni permitir el
  daño a la misma por su uso, ni usar dicha Infraestructura de cualquier manera
  que pueda crear interferencia ilógica e irrazonable con el servidor de
  procesamiento de pagos o con los Servicios.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente se obliga a
  cumplir con los siguientes requerimientos técnicos de la Infraestructura:</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>i.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Realizar por su cuenta todas las adecuaciones
  necesarias para la instalación de la Infraestructura; </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>ii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Cumplir con todas las especificaciones técnicas
  requeridas para operar la Infraestructura Wirebit de conformidad con los
  manuales y la normatividad aplicable; y;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span>iii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Contar con el equipo necesario para lograr el
  enlace y comunicación indispensable para la prestación del Servicio objeto de
  los presentes Términos; </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente se obliga a
  efectuar por su cuenta las modificaciones, adiciones o mejoras a sus sistemas,
  procesos, infraestructura y <i>software </i>asociados que WIREBIT le solicite
  por cualquiera de los medios pactados en  los presentes Términos, cuando dicha
  solicitud derive de nuevas prácticas, metodologías o tecnologías desarrolladas
  para optimizar el proceso de aceptación de Tarjetas a través de la
  Infraestructura o bien de ordenamientos de las autoridades competentes; leyes,
  circulares y en general de cualquier disposición legal aplicable; reglamentación
  de los Titulares de Marcas, entre otros, o emisores; convenios interbancarios
  celebrados entre el Emisor o lineamientos emitidos por cualquier organismo
  autorregulatorio bancario reconocido por la legislación aplicable.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Las adiciones,
  modificaciones o mejoras solicitadas por WIREBIT al Cliente deberán ser
  realizadas por este último en la forma y términos que aquel determine en
  función de la circunstancia, regla, lineamiento o supuesto normativo del que
  derive la respectiva adición, modificación o mejora. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En virtud de lo
  anterior, el Cliente asume cualquier riesgo operativo, económico o legal que se
  materialice ante el incumplimiento a lo pactado en este párrafo o el
  cumplimiento parcial o extemporáneo, incluyendo en forma enunciativa mas no
  limitativa:</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>i.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>El rechazo de las Transacciones procesadas por
  el Servicio de Tarjeta no Presente operadas fuera de especificaciones;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>ii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Sanciones económicas de los Titulares de
  Marcas, entre otros, o emisores, anexando los comprobantes de las
  modificaciones solicitadas e incumplidas, así como el antecedente de las
  sanciones económicas involucradas;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span>iii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>La imposición de multas por incumplimiento a
  disposiciones legales o administrativas emitidas por autoridad competente;</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span>iv.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>La aplicación de tasas de descuento o tarifas
  fijas diferenciadas por el incumplimiento; </span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>v.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>La generación de Contracargos; y </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que el
  Cliente desee cambiar el lugar original de instalación de la Infraestructura,
  deberá avisar por escrito a WIREBIT con 10 (diez) días hábiles de anticipación,
  en el entendido que todos los gastos que se generen por ello correrán por
  cuenta del Cliente.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Las Partes reconocen y
  acuerdan que el Cliente tendrá derecho únicamente de usar el Infraestructura Wirebit,
  limitándose al uso que se señala en los presentes Términos.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>CONTRASEÑA</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>WIREBIT proporcionará al
  Cliente la contraseña principal necesaria para acceder a la Infraestructura y,
  en su caso, una contraseña de administrador a partir del cual el Cliente podrá
  crear nuevas contraseñas y asignarlas a los usuarios que seleccione bajo su
  responsabilidad. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>La contraseña de
  administrador será asignada por WIREBIT a su entera discreción, previa
  solicitud elaborada por el Cliente en el formato que éste determine para tal
  efecto, misma que deberá ser debidamente suscrita por el Cliente o su
  representante legal, según sea el caso, y deberá acompañarse de una copia de la
  identificación oficial con fotografía de éste y remitirla a WIREBIT vía correo
  electrónico o conforme al proceso implementado por WIREBIT que se encuentre
  vigente en la fecha de la solicitud. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En todo caso el Cliente
  responderá por el uso y manejo de la contraseña principal, de la contraseña de
  administrador y de las que en su caso sean creadas a partir de éste,
  obligándose a resarcir a WIREBIT por los daños y perjuicios que en su caso le
  sean ocasionados por el uso o manejo indebido de dichas contraseñas, imputable
  al propio Cliente y/o a sus usuarios. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>FUNCIONAMIENTO
  DEL INFRAESTRUCTURA</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente se obliga a
  reportar a WIREBIT de inmediato cualquier falla o irregularidad que se presente
  en el funcionamiento de la Infraestructura con la finalidad de que WIREBIT
  atienda dicha falla o irregularidad de forma efectiva. Asimismo, WIREBIT
  notificará al Cliente fallas o irregularidades ocasionadas por causas
  imputables a WIREBIT o terceros, notificando un plazo estimado para solucionar
  dichas fallas o irregularidades.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Por su <span
  style='background:white'>parte, WIREBIT se obliga a prestar al Cliente el
  servicio de mantenimiento preventivo y correctivo de la Infraestructura,</span>
  consistente en la revisión y en su caso corrección de fallas o errores
  imputables a WIREBIT o al Infraestructura Wirebit, la actualización del
  correspondiente <i>software</i> o nuevas versiones y servicios de soporte sobre
  la Infraestructura Wirebit, tales como mantenimiento de la Plataforma o enlaces
  de comunicación, para lo cual las Partes observarán lo siguiente:</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>i.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Al momento de existir una falla, el Cliente
  deberá reportarla a WIREBIT, debiendo señalar por lo menos lo siguiente:</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>a.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Descripción de los eventos ocurridos previos a
  la falla, tales como cambios al ambiente técnico o cualquier otra actividad
  realizada por el Cliente que haya podido causar un efecto a la Infraestructura
  y el detalle de procedimientos, actividades o información que pudiera producir
  la falla;</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>b.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Información de transaccionalidad de al menos
  las 48 (cuarenta y ocho) horas previas al acontecimiento;</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>c.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Instrucciones de procesos, procedimientos y
  actividades o información que pudiera producir la falla, incluyendo información
  específica e información propia del Cliente; y</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>d.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Detalle de cualquier actividad que el Cliente
  haya realizado o implementado.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>ii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Una vez que WIREBIT haya recibido el reporte de
  la falla por parte del Cliente, WIREBIT se obliga a:</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>a.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Realizar las acciones pertinentes para confirmar
  si la falla en la Infraestructura Wirebit es imputable al Cliente, a WIREBIT o
  al propio Infraestructura;</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>b.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Con base en lo anterior, reparar la falla de
  acuerdo a lo establecido por Wirebit en caso de que ésta le sea imputable a o
  en la Infraestructura.</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>c.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Comunicar al Cliente de las fallas no
  imputables a WIREBIT ni a la Infraestructura, en cuyo caso WIREBIT, se reserva
  el derecho cargar en el Fondo de Reserva el importe de los gastos debidamente
  documentados en que WIREBIT incurra por solucionar o reparar la falla provocada
  por el Cliente, incluyendo los generados por el tiempo invertido y los
  materiales utilizados, según sea el caso. </span></p>

  <p class=MsoNormal style='margin-left:70.9pt;text-align:justify;border:none'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente
  autoriza e instruye a WIREBIT, a cargar en su Fondo de Reserva el importe de
  los gastos a que se refiere este inciso; y,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>d.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Asegurar que el servicio de mantenimiento
  correctivo y preventivo correspondiente sea prestado por personal debidamente
  capacitado.</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;border:none'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>DESINSTALACIÓN
  DEL SOFTWARE</span></u></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><a name="_Hlk44342648"><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente acepta
  que en caso de incumplimiento a los presentes Términos WIREBIT podrá suspender
  el uso de la Infraestructura y en su caso rescindir los presentes Términos sin
  responsabilidad alguna estando obligado el Cliente a desinstalar cualquier
  software que derivado de los presentes Términos tenga en su Plataforma o sistemas.</span></a></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>WIREBIT estará facultado
  para verificar a través del agente seleccionado a su entera discreción, la
  debida desinstalación del software correspondiente. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que el
  Cliente no desinstale cualquier software de WIREBIT, el Cliente se obliga a cubrir
  a WIREBIT el costo de los daños y perjuicios que en su caso le sean ocasionados
  por el uso indebido que se dé al mismo, con independencia de que el Cliente
  autoriza en forma expresa e irrevocable a WIREBIT a cargar al Fondo de Reserva los
  daños y perjuicios ocasionados. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>PROCESO DE
  AUTORIZACIÓN</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente reconoce y
  acepta que el proceso de autorización se sujetará a lo siguiente:</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span>i.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Una vez que el Tarjetahabiente haya
  seleccionado los productos o servicios que desee adquirir con cargo a su Tarjeta,
  el Cliente confirmará el nombre del Tarjetahabiente que aparece en la Tarjeta,
  en su caso, el domicilio de entrega de la mercancía y el total de los
  productos, servicios o pagos seleccionados, informándole el monto total de los
  mismos, del que deberá desglosar entre otros, el IVA, costo por envío, costo
  unitario, costo total y cargos adicionales que pudiesen aplicar, permitiendo al
  Tarjetahabiente agregar o eliminar productos o servicios a los previamente
  seleccionados, antes de aceptar el cargo a su Tarjeta. El Cliente deberá
  indicar al Tarjetahabiente los tiempos de entrega de sus productos o prestación
  de sus servicios y precisar sus políticas de precios, devoluciones y
  cancelaciones.</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><a name="_Hlk44345103"><span lang=ES-MX
  style='font-size:8.0pt;line-height:115%;font-family:"Arial",sans-serif'><span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>ii.<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Una vez que el Tarjetahabiente acepte las
  condiciones, políticas, términos y condiciones a que se refiere el inciso
  anterior, deberá proporcionar la siguiente información:</span></a></p>

  <p class=MsoListParagraphCxSpFirst style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:1.0in;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>a.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Nombre completo del Tarjetahabiente,</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:1.0in;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>b.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Número de Tarjeta a la cual se hará el cargo,</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:1.0in;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>c.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Fecha de vigencia de la Tarjeta</span></p>

  <p class=MsoListParagraphCxSpLast style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:1.0in;text-align:justify;text-indent:-.25in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>d.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>CVV2/CVC2/CID</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span>iii.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Una vez que el Emisor que corresponda autorice
  a través de WIREBIT el cargo a la Tarjeta de que se trate, el Cliente
  procederá, en su caso, a entregar al Tarjetahabiente o al tercero autorizado la
  dirección consignada en la orden de pedido el (los) producto (s) o servicio(s)
  adquirido(s), en las condiciones y dentro del período ofrecidos, previa
  revisión de la correspondiente identificación oficial con fotografía y firma
  (para los efectos de este Anexo es válida la credencial de elector expedida por
  el Instituto Nacional Electoral (o la que en su caso la sustituya) o pasaporte
  vigente);</span></p>

  <p class=MsoNormal style='margin-left:.5in;text-align:justify;text-indent:-.5in;
  line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span>iv.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>El Cliente deberá generar un acuse de recibo
  que lo acredite, el cual deberá contener en adición a la información contenida
  en la orden de pedido, la siguiente información:</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>a.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Número de orden de pedido,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>b.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Nombre del Tarjetahabiente,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>c.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>En su caso, nombre del tercero autorizado por
  el Tarjetahabiente para recibir los bienes o la prestación de los servicios,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>d.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Número de autorización otorgado por el emisor
  para la operación de la respectiva Transacción procesada por el Servicio de
  Tarjeta no Presente,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>e.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Fecha y hora de entrega de la mercancía o de la
  prestación del servicio,</span></p>

  <p class=MsoNormal style='margin-left:1.0in;text-align:justify;text-indent:
  -.25in;line-height:115%;border:none'><span lang=ES-MX style='font-size:8.0pt;
  line-height:115%;font-family:"Arial",sans-serif'>f.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span><span lang=ES-MX style='font-size:8.0pt;line-height:115%;
  font-family:"Arial",sans-serif'>Aceptación expresa del Tarjetahabiente, con
  respecto al cargo efectuado en su Tarjeta con motivo de la adquisición de los
  bienes entregados o los servicios prestados.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Para efectos de
  aclaraciones el Cliente deberá entregar a WIREBIT el acuse que acredite la
  recepción del bien o del servicio por parte del Tarjetahabiente o, en su caso,
  el tercero autorizado por éste a fin de que WIREBIT esté en posibilidad de
  presentarla ante posibles inconformidades, sin que ello implique que éstas sean
  resueltas a su favor.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>VIGENCIA</span></u></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Los presentes Términos
  permanecerán vigentes indefinidamente, hasta en tanto una de las Partes los des
  por terminado de conformidad con lo dispuesto en el apartado <i>Terminación.</i></span></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>TERMINACIÓN</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>WIREBIT<b> </b>tendrá la
  facultad de (a) suspender temporalmente la prestación de los Servicios, o (b)
  demorar las transferencias a la Cuenta de Depósito por cualquier razón y en
  cualquier momento, sin necesidad de notificar al<b> </b>Cliente. Asimismo, WIREBIT<b>
  </b>tendrá la facultad de dar por terminados los presentes Términos, mediante
  notificación al Cliente con al menos 5 (cinco) días hábiles de anticipación. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>No obstante lo establecido
  en el párrafo inmediato anterior, WIREBIT<b> </b>podrá dar por terminados  los
  presentes Términos sin previo aviso al Cliente cuando éste (a) (b) genere un
  riesgo de crédito o fraude, (c) proporcione cualquier información falsa,
  incompleta, inexacta o engañosa, (d) realice cualquier actividad fraudulenta o
  ilegal o (e) el<b> </b>Cliente y/o los propietarios o representantes legales de
  éstos se encuentren incluidos en la lista de excepción en materia de prevención
  de lavado de dinero y financiamiento al terrorismo, en la lista de personas
  bloqueadas, de conformidad a la legislación vigente aplicable, </span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>(f) en caso
  de que el Cliente presente un periodo de inactividad por 6 (seis) meses
  consecutivos.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'> </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Asimismo, el Cliente
  podrá dar por terminados los presentes Términos, mediante notificación por
  escrito a<b> </b>WIREBIT, con al menos 30 (treinta) días naturales de
  anticipación, en el entendido de que WIREBIT<b> </b>no será responsable de
  ninguna compensación, reembolso ni daño derivado de cualquier terminación o
  suspensión de los Servicios. </span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><a name="_1t3h5sf"></a><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>La rescisión
  de los presentes Términos no libera al Cliente de ninguna obligación de pago en
  favor de WIREBIT<b> </b>de la Tasa de Descuento o cualesquiera otros cargos
  devengados no pagados. Asimismo, las Partes reconocen que, no obstante, se dé
  por terminado o se rescinda los presentes Términos, existirán ciertas
  obligaciones que subsistirán a la terminación o rescisión de éste.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><a name="_4d34og8"></a><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>En virtud de
  lo anterior el Cliente reconoce que mantendrá fondos suficientes en el Fondo de
  Reserva a efecto de que éste último pueda hacer frente a cualquier monto de
  Contracargos, devoluciones, ajustes, cuotas, tasas y/o penalizaciones de las
  Redes de Pagos con Tarjetas por un plazo de 180 (ciento ochenta) días naturales
  contados a partir de la terminación de los presentes Términos.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><a name="_2s8eyo1"></a><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>Una vez
  transcurrido el plazo de 180 días mencionado en el párrafo inmediato anterior, WIREBIT
  se obliga a entregar al Cliente la cantidad que integre el Fondo de Reserva
  dentro de los 30 (treinta) días hábiles siguientes a que termine dicho plazo.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Asimismo, el Cliente se
  obliga a cumplir con las obligaciones de indemnización impuestas a su cargo de
  conformidad con lo estipulado en los presentes Términos por un plazo de 3
  (tres) años contados a partir de la terminación o rescisión de los presentes
  Términos. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>RESOLUCIÓN DE
  CONTROVERSIAS</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Las partes acuerdan que
  en caso de que se presente cualquier controversia derivada de lo establecido en
  los presentes Términos o que guarde relación con él o con su incumplimiento,
  las partes accederán a un proceso no discriminatorio, libre de conflictos de
  interés y expedito para la resolución de las posibles controversias que puedan
  llegar a existir. Por lo anterior, las partes deberán consultarse y negociar
  entre ellas y, reconociendo sus intereses en común, tratarán de alcanzar una
  solución satisfactoria. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Si las partes no
  llegaren a un acuerdo dentro de un periodo de 30 (treinta) días naturales,
  cualquiera de las partes podrá, mediante notificación a la otra parte proceder
  a la rescisión de los presentes Términos, de acuerdo con lo estipulado en el
  apartado de <i>Rescisión.</i></span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>RESCISIÓN</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>WIREBIT podrá rescindir
  los presentes Términos sin previo aviso en caso de que el Cliente haya violado
  alguno de los acuerdos establecidos en los mismos, cualquier otro convenio que
  haya celebrado con WIREBIT o las políticas de WIREBIT, </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>La rescisión de los presentes
  Términos no liberará al Cliente de ninguna obligación de pago en favor de WIREBIT
  derivado de Tarifas, Contracargos, multas, penas convencionales o cualquier
  otro cargo derivado de las operaciones realizadas al amparo de los presentes
  Términos. Por lo anterior, el Cliente entiende y acepta que, atendiendo a lo
  establecido en el apartdo <i>Fondo de Reserva. </i>WIREBIT podrá disponer en
  beneficio de éste o un tercero, cualquier monto del Fondo de reserva, sin
  previa notificación ni autorización adicional, para cobrar cualesquiera
  cantidades que el Cliente deba conforme a los presentes Términos, hasta por un
  plazo de 180 (ciento ochenta) días a partir de la última transacción realizada
  en la Plataforma del Cliente.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Por su parte, el Cliente
  podrá rescindir los presentes Términos, mediante notificación por escrito a WIREBIT,
  con al menos 30 (treinta) días hábiles de anticipación a que surta efectos la
  rescisión. En el entendido que WIREBIT no será responsable de ninguna
  compensación, reembolso ni daño derivado de cualquier terminación o suspensión
  de los servicios.</span></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>INDEMNIZACIÓN</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente deberá
  indemnizar y sacar en paz y a salvo a WIREBIT, sus consejeros, apoderados,
  empleados y accionistas, de cualquier reclamación, pérdida, daño, perjuicio,
  multa, interés y/o gasto (incluyendo, sin estar limitado a, honorarios de
  abogados) que resulten de: (a) cualquier violación de las declaraciones u
  obligaciones estipuladas en  los presentes Términos, incluyendo, sin estar
  limitado a, cualquier violación de las políticas de WIREBIT<b> </b>y/o las
  Reglas de las Redes, (b) el uso ilegal o inapropiado de los Servicios, (c)
  cualquier Transacción que realice el Cliente, (d) la violación de cualquier
  derecho de propiedad intelectual, (e) la violación de cualquier ley, reglamento
  o circular vigente en los Estados Unidos Mexicanos, (f) cualquier uso de la
  Cuenta de Depósito que realicen terceros, así como (g) cualquier Contracargo. </span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>RESPONSABILIDAD</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>WIREBIT<b> </b>no asume
  responsabilidad alguna que derive de cualquier (a) error, equivocación o
  inexactitud en la prestación los Servicios, (b) daño que resulte del uso de los
  Servicios, (c) acceso o uso no autorizado de la información almacenada en sus
  servidores, (d) interrupción o suspensión de los Servicios, (e) falla, <i>bugs</i>,
  virus, caballos de Troya (<i>Trojan horses</i>) o similares que hayan sido
  transmitidos mediante la prestación de los Servicios, (f) daño o perjuicio
  derivado del uso de cualquier contenido o dato publicado, enviado o transmitido
  mediante los Servicios, (g) daño derivado del uso que haga el Cliente de los
  servicios prestados al amparo de los presentes Términos; (h) uso de los
  Servicios de Terceros (según dicho término se define más adelante) o de los sitios
  web de terceros; y (i) cualquier falla o defecto de la Infraestructura.</span></p>

  <p class=MsoNormal style='text-align:justify'><u><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'><span style='text-decoration:
   none'>&nbsp;</span></span></u></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>PREVENCIÓN DE
  LAVADO DE DINERO</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente deberá</span><b><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'> </span></b><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>apegarse a
  las leyes principios y políticas públicas emitidas por la autoridad competente,
  aplicables y vigentes dentro de territorio nacional en materia de prevención,
  detección y sanción de hechos de corrupción, faltas administrativas y
  prevención de lavado de dinero.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que WIREBIT
  sospeche que el Cliente lleva a cabo operaciones con recursos de procedencia
  ilícita, podrá rescindir  los presentes Términos sin responsabilidad alguna
  para WIREBIT, sin perjuicio de las acciones legales que pueda ejercer.</span></p>

  <p class=MsoNormal style='text-align:justify'><u><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'><span style='text-decoration:
   none'>&nbsp;</span></span></u></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>HARDWARE Y
  SERVICIOS DE TERCEROS</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Todo el hardware,
  incluyendo productos de terceros que se incluyan o vendan para poder prestar
  los Servicios se proveen exclusivamente con la garantía y otros términos que
  especifica el fabricante de estos, quien es el responsable del servicio y el
  soporte de dichos productos. Para obtener asistencia de servicio, soporte o
  garantía, el Cliente deberá contactar al fabricante del hardware y/o producto
  en forma directa. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que, como
  parte de los Servicios, el Cliente reciba ofertas de servicios, productos y
  promociones que provean terceros (los “Servicios de Terceros”) el Cliente será
  el responsable de revisar y entender los términos y condiciones que se
  relacionan con los Servicios de Terceros. WIREBIT<b> </b>no será responsable
  del desempeño de los terceros en la prestación de los Servicios de Terceros. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Asimismo, WIREBIT<b> </b>podrá
  incluir vínculos a sitios web operados por terceros. El Cliente asume cualquier
  riesgo, daño o perjuicio que resulte del uso y acceso a los sitios web de
  terceros. </span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>INDEPENDENCIA
  Y RESPONSABILIDAD LABORAL</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Dado que las Partes son
  personas independientes, ninguna de ellas podrá actuar en nombre y
  representación de la otra Parte, ni como representante o mediador de la otra,
  de forma tácita o expresa, sin autorización previa, expresa y por escrito de la
  otra Parte.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Las Partes reconocen que
  ni la aceptación de  los presentes Términos ni la ejecución del mismo implican
  una relación laboral entre ambas, ni entre el personal o prestadores de
  servicios de una y de la otra, obligándose ambas Partes, en este acto, a sacar
  en paz y a salvo a la otra Parte, en caso de que cualquiera de los empleados o
  prestadores de servicios de alguna de ellas presentara alguna demanda o
  reclamación en contra de la otra Parte, sus accionistas, funcionarios,
  consejeros, directivos, asesores, prestadores de servicios o empleados, quedando,
  asimismo, obligadas a pagar a la Parte afectada erogaciones originadas por
  litigios así como los honorarios razonables de abogados. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>PROTECCIÓN DE
  DATOS PERSONALES</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente reconoce que,
  de conformidad con la fracción IV del Artículo 10 de la Ley Federal de
  Protección de Datos Personales en Posesión de los Particulares y demás
  disposiciones aplicables de su reglamento y/o los lineamientos en materia de
  protección de datos personales emitidos por la Secretaría de Economía (la “Ley
  de Datos Personales”), el tratamiento de los datos personales del<b> </b>Cliente
  no se encuentra sujeto a su consentimiento, en virtud de que el tratamiento
  tiene como propósito cumplir con obligaciones derivadas de una relación
  jurídica entre WIREBIT<b> </b>y el Cliente.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente tendrá la
  obligación de generar un aviso de privacidad que cumpla con lo dispuesto por la
  Ley de Datos Personales y deberá poner su aviso de privacidad integral a
  disposición de sus clientes previo al tratamiento de cualquier dato personal. </span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>El Cliente indemnizará y
  sacará en paz y a salvo a WIREBIT<b> </b>de cualquier daño, perjuicio y gasto
  (incluyendo honorarios de abogados) que deriven de cualquier procedimiento
  sancionatorio o de cualquier otra naturaleza iniciado en contra de WIREBIT<b> </b>en
  virtud de cualquier transferencia de datos personales que haga el Cliente a WIREBIT<b>
  </b>que no cumpla con lo dispuesto por la Ley de Datos Personales.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><a name="_Hlk36835850"><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>FORMAS DE
  AUTENTICACIÓN</span></u></b></a></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>WIREBIT podrá permitir
  al Cliente el uso de la firma electrónica avanzada o cualquier otra forma de
  autenticación para la contratación de los servicios, realizar Operaciones o
  para firmar cualquier documentación y/o manifestar su conformidad con cualquier
  otro asunto relacionado con la prestación de los servicios.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Dichas formas de
  autenticación producirán los mismos efectos que las leyes otorgan a los
  documentos suscritos con firma autógrafa y, en consecuencia, tendrán el mismo
  valor probatorio, siempre que cumplan con las disposiciones legales aplicables.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>MODIFICACIÓN</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Salvo por los casos
  expresamente incluidos en los presentes Términos, ninguna enmienda,
  modificación o disposición complementaria a los presentes Términos y sus anexos
  se considerará válida, a menos que conste en un documento escrito y debidamente
  firmado por los representantes legales de ambas Partes.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>INTEGRIDAD Y
  ENCABEZADOS</span></u></b></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Todos los textos y
  anexos de los presentes Términos, excepto los encabezados, se considerarán como
  parte integrante del mismo, una vez firmados por ambas Partes. Todos los
  encabezados de los apartados, establecidos en los presentes Términos, se
  entenderán únicamente puestos como referencia por lo que no afectarán el
  sentido, interpretación, alcance o efectos de los presentes Términos o
  cualquiera de sus estipulaciones.</span></p>

  <p class=MsoNormal style='text-align:justify;text-indent:35.4pt'><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>NO RENUNCIA</span></u></b></p>

  <p class=MsoNormal align=center style='text-align:center'><u><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'><span style='text-decoration:
   none'>&nbsp;</span></span></u></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>La falta de ejercicio de
  algún derecho o de la aplicación de alguna de las sanciones estipuladas en los
  presentes Términos, no se considerará en ninguna circunstancia como una
  renuncia de derechos de la Parte correspondiente, para ocasiones subsecuentes.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center;border:none'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>CESIÓN</span></u></b></p>

  <p class=MsoNormal align=center style='text-align:center;border:none'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'><span
   style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoNormal style='text-align:justify;border:none'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Los presentes Términos y
  los derechos u obligaciones bajo el mismo no podrán ser cedidos o transmitidos
  de manera alguna por el Cliente sin el previo consentimiento por escrito de<b> </b>WIREBIT.</span></p>

  <p class=MsoNormal style='text-align:justify;border:none'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify;border:none'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>WIREBIT<b> </b>tendrá el
  derecho de ceder cualquiera de sus derechos y obligaciones bajo los presentes
  Términos sin requerir autorización o notificación previa del Cliente.</span></p>

  <p class=MsoNormal style='text-align:justify;border:none'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>DIVISIBILIDAD</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>En caso de que cualquier
  disposición de los presentes Términos, o la aplicación de esta, por cualquier
  motivo sea considerada por un tribunal competente como inválida o inejecutable,
  dicha disposición deberá ser modificada o interpretada por dicho tribunal de
  manera que refleje la intención de las Partes y las Partes deberán remplazar
  cualquier disposición declarada inválida o inejecutable por una disposición o
  disposiciones válidas y ejecutables. Todas las demás disposiciones de los
  presentes Términos se mantendrán en pleno vigor y efecto.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>ACUERDO TOTAL</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Los presentes Términos
  constituye el acuerdo integral y entendimiento final entre las Partes respecto
  de los Servicios a ser prestados por WIREBIT<b> </b>al Cliente. Las Partes
  manifiestan que en la celebración de los presentes Términos no ha mediado ni
  existe dolo, mala fe, error, lesión o cualquier otro vicio del consentimiento
  que pudiera invalidarlo total o parcialmente, ya que mutuamente han convenido
  sobre el objeto de los presentes Términos, su Tasa de descuento y sus
  cláusulas.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>NOTIFICACIONES
  A LAS PARTES</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Las partes acuerdan que
  cualquier notificación que deba hacer el Cliente a WIREBIT<b> </b>conforme a
  los presentes Términos podrá realizarla vía correo electrónico a la siguiente
  dirección:</span><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'><a
  name=Texto1></a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>  </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Cualquier notificación
  que deba hacer Wirebit a el Cliente conforme a los presentes Términos podrá
  realizarla al correo electrónico establecida en la Solicitud de Afiliación. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Las partes acuerdan que
  cualquier notificación realizada por el medio establecido en el presente
  apartado será válida para todos los efectos legales.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal align=center style='text-align:center'><b><u><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'>LEGISLACIÓN
  APLICABLE Y JURISDICCIÓN</span></u></b></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Los presentes Términos
  se regirá e interpretará de conformidad con la legislación aplicable en la
  Ciudad de México.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><b><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>LAS PARTES</span></b><span
  lang=ES-MX style='font-size:8.0pt;font-family:"Arial",sans-serif'> se someten
  expresamente a la jurisdicción de los tribunales competentes de la Ciudad de
  México, renunciando a cualquier jurisdicción que pudiere corresponderles en
  virtud de su domicilio presente o futuro, o por cualquier otra causa. </span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify;border:none'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>Wirebit podrán permitir
  para la aceptación de los presentes Términos el uso de la firma electrónica
  avanzada o cualquier otra forma de autenticación, la cual producirá los mismos
  efectos que las leyes otorgan a los documentos suscritos con firma autógrafa y,
  en consecuencia tendrá el mismo valor probatorio, siempre que cumplan con las
  disposiciones legales aplicables.</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:justify'><span lang=ES-MX
  style='font-size:8.0pt;font-family:"Arial",sans-serif'>                </span></p>

  <p class=MsoNormal style='text-align:justify;line-height:115%'><b><span
  lang=ES-MX>&nbsp;</span></b></p>

  </div>

  </div>
  `
  export default html
